if (document.getElementById('web-on-boarding-test')) {
    class getTranslationUtilities {
        getTranslation(text) {
            try {
                switch (text) {
                    case "Are you taking this quiz for yourself or for your child?":
                        return 'Machst du den Allergie-Aktionsplan für dich selbst oder für dein Kind?';
                    break;  
                    case "Myself":
                        return 'Für mich selbst';
                    break;  
                    case "My child":
                        return 'Für mein Kind';
                    break;  
                    case "What are your goals in exploring allergies?":
                        return 'Was erhoffst du dir von diesem Allergie-Aktionsplan?';
                    break;  
                    case "Find out more about allergies in general":
                        return 'Mehr über Allergien im Allgemeinen erfahren';
                    break;  
                    case "Determine if I might have an allergy":
                        return 'Herausfinden, ob ich vielleicht eine Allergie habe';
                    break;  
                    case "Understand allergy treatments":
                        return 'Behandlungsmöglichkeiten für Allergien verstehen';
                    break;  
                    case "Prepare for a doctor’s appointment":
                        return 'Mich auf einen Arzttermin vorbereiten';
                    break;  
                    case "Make allergy management easier":
                        return 'Tipps, um den Umgang mit Allergien zu erleichtern';
                    break;  
                    case "Something else":
                        return 'Etwas anderes';
                    break;  
                    case "Have your allergies been diagnosed by a doctor?":
                        return 'Wurde bereits eine Allergie (oder mehrere) von einer Ärztin oder einem Arzt bei dir diagnostiziert?';
                    break;  
                    case 'Yes':
                        return 'Ja';
                    break;  
                    case 'No':
                        return 'Nein';
                    break;
                    case 'BACK':
                        return 'ZURÜCK';
                    break;  
                    case 'NEXT':
                        return 'WEITER';
                    break;  
                    case 'SUBMIT':
                        return 'Auswertung';
                    break;  
                    case 'What allergies have you been diagnosed with?':
                        return 'Welche Allergien wurden bei dir bereits diagnostiziert?';
                    break;
                    case 'Pollen':
                        return 'Pollen';
                    break;            
                    case 'Grass':
                        return 'Gräserpollen';
                    break;            
                    case 'Tree':
                        return 'Baumpollen';
                    break;            
                    case 'Weed':
                        return 'Kräuterpollen';
                    break;            
                    case 'Dust mite':
                        return 'Hausstaubmilben';
                    break;                       
                    case 'Animals':
                        return 'Tierhaare';
                    break;  
                    case 'Certain foods':
                        return 'Nahrungsmittel';
                    break;  
                    case 'Insect stings':
                        return 'Insektengift';
                    break;  
                    case 'Other':
                        return 'anderer Allergie-Auslöser';
                    break;  
                    case 'Other1':
                        return 'Andere';
                    break;
                    case "Other/Don’t know":
                        return 'Etwas anderes/Ich weiß es nicht';
                    break;  
                    case "How are your eyes affected?":
                        return 'Welche Beschwerden hast du im Bereich der Augen?';
                    break;  
                    case 'Eyes':
                        return 'Augen';
                    break;            
                    case 'Itchy':
                        return 'Jucken';
                    break;            
                    case 'Watery':
                        return 'Tränen';
                    break;            
                    case 'Red':
                        return 'Rötung';
                    break; 
                    case 'Select specific symptoms':
                        return 'Wähle Symptome aus';
                    break; 
                    case 'Rate the overall impact':
                        return 'Wie stark bist du betroffen?';
                    break;  
                    case 'NOT AFFECTED':
                        return 'GAR NICHT BETROFFEN';
                    break;  
                    case 'VERY AFFECTED':
                        return 'STARK BETROFFEN';
                    break;  
                    case 'Understand the scale':
                        return 'Die Skala verstehen';
                    break; 
                    case "How is your nose affected?":
                        return 'Welche Beschwerden hast du im Bereich der Nase?';
                    break;
                    case 'Nose':
                        return 'Nase';
                    break;  
                    case 'Stuffy':
                        return 'Verstopft';
                    break;            
                    case 'Runny':
                        return 'Läuft';
                    break;            
                    case 'Sneezing':
                        return 'Niesen';
                    break;  
                    case "How are your sleep and energy levels affected?":
                        return 'Inwiefern sind dein Schlaf und deine Leistungsfähigkeit betroffen?';
                    break;                       
                    case 'Tiredness':
                        return 'Müdigkeit';
                    break;  
                    case "Do you have any of these breathing issues?":
                        return 'Hast du Beschwerden im Bereich der Atemwege?';
                    break;
                    case 'Coughing':
                        return 'Husten';
                    break;            
                    case 'Tight chest':
                        return 'Engegefühl in der Brust';
                    break;                       
                    case 'Wheezing':
                        return 'Pfeifendes Atmen';
                    break;         
                    case 'None':
                        return 'Keine';
                    break;  
                    case "Do you feel in control of your symptoms?":
                        return 'Hast du das Gefühl, deine Symptome gut im Griff zu haben?';
                    break;
                    case "Which allergy treatments are you aware of?":
                        return 'Welche Allergiebehandlungen kennst du?';
                    break;
                    case "Symptomatic medicine such as antihistamines or corticosteroids":
                        return 'Symptomatische Medikamente wie Antihistaminika oder Kortison';
                    break;
                    case 'Tablets/capsules':
                        return 'Tablette';
                    break;
                    case 'Syrup':
                        return 'Saft';
                    break;
                    case 'Nasal spray':
                        return 'Nasenspray';
                    break;
                    case 'Eye drops':
                        return 'Augentropfen';
                    break;
                    case 'Inhaler':
                        return 'Spray oder Inhalationslösung';
                    break;
                    case 'Creams or lotions':
                        return 'Creme';
                    break;
                    case "Symptomatic medicine such as antihistamines or corticosteroids":
                        return 'Allergie-Immuntherapie';
                    break;
                    case 'Tablets':
                        return 'Tabletten';
                    break;
                    case 'Drops':
                        return 'Tropfen';
                    break;
                    case 'Shots':
                        return 'Spritzen';
                    break;
                    case "Which aspects of your life are affected?":
                        return 'Welche Bereiche deines Lebens sind betroffen?';
                    break;
                    case 'Sleep':
                        return 'Schlaf';
                    break;            
                    case 'Family routines':
                        return 'Familienalltag';
                    break;            
                    case 'Concentration at school/work':
                        return 'Konzentration Schule und Arbeit';
                    break;                       
                    case 'Sports':
                        return 'Sport';
                    break;    
                    case "When are your symptoms worse?":
                        return 'Wann sind deine Symptome am schlimmsten?';
                    break;   
                    case 'Spring':
                        return 'Frühling';
                    break;            
                    case 'Summer':
                        return 'Sommer';
                    break;                       
                    case 'Fall':
                        return 'Herbst';
                    break;         
                    case 'Winter':
                        return 'Winter';
                    break;
                    case 'All year round':
                        return 'Das ganze Jahr über';
                    break;            
                    case 'Indoors':
                        return 'In Innenräumen';
                    break;                       
                    case 'Outdoors':
                        return 'Im Freien';
                    break;         
                    case 'Don’t know':
                        return 'Ich weiß es nicht';
                    break;  
                    case "Any idea what triggers your symptoms?":
                        return 'Hast du eine Idee, was deine Symptome auslösen könnte?';
                    break;  
                    case 'Does anyone in your family have allergic conditions, such as hay fever, asthma, hives or rashes?':
                        return 'Hat ein Mitglied deiner Familie eine allergische Erkrankung wie Heuschnupfen, Asthma oder Hautausschläge?';
                    break;  
                    case 'Skip':
                        return 'Keine Angabe';
                    break;  
                    case 'Have you ever had these conditions?':
                        return 'Leidest oder hast du bereits unter einer (oder mehreren) der folgenden Erkrankungen gelitten?';
                    break;  
                    case 'Eczema':
                        return 'Ekzeme';
                    break;  
                    case 'Asthma':
                        return 'Asthma';
                    break;  
                    case 'Not affected':
                        return 'Nicht betroffen';
                    break;
                    case 'You suspect you may be experiencing ':
                        return 'Du vermutest, dass du unter einer Allergie leidest und bist auf der Suche nach weiteren Informationen. Du hast bereits ';
                    break;
                    case " allergy. Let's work together to navigate your next steps.":
                        return ' im Verdacht. Lass uns gemeinsam deine nächsten Schritte planen.';
                    break;
                    case "You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(multi)":
                        return 'Du vermutest, dass du unter einer Allergie leidest und bist auf der Suche nach weiteren Informationen. Du hast bereits mehrere Auslöser im Verdacht. Lass uns gemeinsam deine nächsten Schritte planen.';
                    break;
                    case "You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(no)":
                        return 'Du vermutest, dass du unter einer Allergie leidest und bist auf der Suche nach weiteren Informationen. Lass uns gemeinsam deine nächsten Schritte planen.';
                    break;
                    case "You suspect ":
                        return 'Du vermutest bei dir eine Allergie auf ';
                    break;
                    case " allergy might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.":
                        return ', bist dir aber noch unsicher. Lass uns gemeinsam Licht ins Dunkel bringen.';
                    break;
                    case " allergy is causing your symptoms and want to learn how to manage it effectively. Your action plan can guide you through your next steps.":
                        return ' und möchtest lernen, wie du die Symptome besser in den Griff bekommen kannst. Lass uns gemeinsam den Aktionsplan für dein weiteres Vorgehen anschauen.';
                    break;
                    case "You suspect allergies might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.":
                        return 'Du vermutest bei dir eine Allergie, bist dir aber noch unsicher, was die Auslöser sind. Lass uns gemeinsam Licht ins Dunkel bringen.';
                    break;
                    case "You suspect allergies are causing your symptoms and want to learn how to manage them more effectively. Your action plan can guide you through your next steps.":
                        return 'Du vermutest bei dir eine Allergie und möchtest lernen, wie du die Symptome besser in den Griff bekommen kannst. Lass uns gemeinsam den Aktionsplan für dein weiteres Vorgehen anschauen.';
                    break;
                    case "Dealing with ":
                        return 'Der Umgang mit einer Allergie auf ';
                    break;
                    case " allergy is challenging, but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.":
                        return ' ist herausfordernd, eine Symptomlinderung war bisher nicht zufriedenstellend. Lass uns gemeinsam deine nächsten Schritte herausfinden.';
                    break;
                    case "Dealing with multiple  allergies is challenging but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.":
                        return 'Der Umgang mit mehreren Allergien ist herausfordernd, eine Symptomlinderung war bisher nicht zufriedenstellend. Lass uns gemeinsam deine nächsten Schritte herausfinden.';
                    break;
                    case "Dealing with allergies is challenging, but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.":
                        return 'Der Umgang mit Allergien ist herausfordernd, eine Symptomlinderung war bisher nicht zufriedenstellend. Lass uns gemeinsam deine nächsten Schritte herausfinden.';
                    break;
                    case "You feel in control of your ":
                        return 'Du hast deine Allergie auf ';
                    break;
                    case " allergy, which is great! We've compiled some tips and resources to help you monitor your symptoms and maintain that control.":
                        return ' gut im Griff – das ist großartig! Wir haben für dich einige Tipps und Informationen zusammengestellt, die dir dabei helfen können, deine Symptome weiterhin gut im Blick zu behalten.';
                    break;
                    case "You feel in control of your allergies, which is great! We've compiled some tips and resources to help you monitor your symptoms and maintain that control.":
                        return 'Du hast deine Allergien gut im Griff – das ist großartig! Wir haben für dich einige Tipps und Informationen zusammengestellt, die dir dabei helfen können, deine Symptome weiterhin gut im Blick zu behalten.';
                    break;
                    case "Discover":
                        return 'Entdecken';
                    break;
                    case "Allergies explained simply":
                        return 'Allergien einfach erklärt';
                    break;
                    case "Tired of itchy eyes and a runny nose?":
                        return 'Genug von juckenden Augen und laufender Nase?';
                    break;
                    case "You might be having an allergic reaction. Allergies happen when your body overreacts to harmless substances like pollen or dust mites, mistaking them for threats. Want to know the top 5 allergy culprits and how to identify the symptoms?":
                        return 'Möglicherweise leidest du unter einer (oder mehreren) Allergie(n). Diese entstehen, wenn dein Immunsystem überreagiert und harmlose Pollen oder Hausstaubmilben fälschlicherweise als Bedrohung ansieht. Möchtest du die 5 häufigsten Allergieauslöser kennenlernen und erfahren, wie du die Symptome erkennst?';
                    break;
                    case "Find out more":
                        return 'Erfahre hier mehr';
                    break;
                    case "Recognise":
                        return 'Erkennen';
                    break;
                    case "Allergies? Or a cold?":
                        return 'Allergie oder Erkältung?';
                    break;
                    case "Sniffling and snuffling? Cold or allergy?":
                        return 'Schniefen und Schnaufen? Erkältung oder Allergie?';
                    break;
                    case "It can be confusing to know what’s causing itchy eyes, runny nose and a cough. But allergies often show different signs than a cold, such as no fever and clear, watery nasal mucus.":
                        return 'Die Ursache von juckenden Augen, einer laufenden Nase und Husten ist manchmal gar nicht so einfach herauszufinden. Beschwerden durch Allergien unterscheiden sich jedoch von denen einer Erkältung.';
                    break;
                    case "See how to spot the difference between a cold and allergies":
                        return 'Erfahre, wie du eine Allergie besser von einer Erkältung unterscheiden kannst';
                    break;
                    case "Plan":
                        return 'Planen';
                    break;
                    case "Track your symptoms":
                        return 'Deine Symptome beobachten';
                    break;
                    case "Get your allergy diary":
                        return 'Hol dir dein Allergie-Tagebuch';
                    break;
                    case "Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively.":
                        return 'Halte deine Symptome fest und gewinne wertvolle Einblicke für dich und deine Ärztin oder deinen Arzt. Werde dir bewusst, wie sich die Allergien auf deinen Alltag auswirken und finde heraus, wie gut dir deine bisherige Behandlung hilft. Dies kann bei der Erstellung eines auf dich zugeschnittenen Behandlungsplans helfen und dazu beitragen, deine Allergiebeschwerden langfristig besser in den Griff zu bekommen.';
                    break;
                    case "Download your allergy diary now.":
                        return 'Lade jetzt dein Allergie-Tagebuch herunter';
                    break;
                    case "Understand":
                        return 'Verstehen';
                    break;
                    case "Allergy treatments":
                        return 'Behandlungsmöglichkeiten';
                    break;
                    case "Treatment options":
                        return 'Allergiebehandlungen';
                    break;
                    case "How to treat allergies":
                        return 'So behandelst du Allergien';
                    break;
                    case "One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms.":
                        return 'Eine der besten Methoden, Allergien zu managen, ist es, die Allergieauslöser zu meiden – aber das ist oft leichter gesagt als getan! Die gute Nachricht? Es gibt viele Möglichkeiten, Allergiesymptome zu lindern.';
                    break;
                    case "Let’s take a look at allergy treatments":
                        return 'Lass uns einen Blick auf die verschiedenen Behandlungsmöglichkeiten werfen';
                    break;
                    case "Find":
                        return 'Finden';
                    break;
                    case "Book a doctor’s appointment":
                        return 'Facharztpraxis finden & Arzttermin buchen';
                    break;
                    case "Find a doctor now":
                        return 'Finde jetzt eine Ärztin oder einen Arzt';
                    break;
                    case "Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you":
                        return 'Hartnäckige Symptome können frustrierend sein. Wenn sie deinen Alltag beeinträchtigen, ist es Zeit, eine Ärztin oder einen Arzt aufzusuchen, um eine Diagnose zu erhalten und Behandlungsmöglichkeiten zu besprechen. Sieh dir unsere Facharztsuche an, um eine Allergiespezialistin oder einen Allergiespezialisten in deiner Nähe zu finden.';
                    break;
                    case "Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you":
                        return 'Hartnäckige Symptome können frustrierend sein. Wenn sie deinen Alltag beeinträchtigen, ist es Zeit, eine Ärztin oder einen Arzt aufzusuchen und Behandlungsmöglichkeiten zu besprechen. Sieh dir unser praktisches Verzeichnis an, um eine Allergiespezialistin oder einen Allergiespezialisten in deiner Nähe zu finden.';
                    break;
                    case "Get ready":
                        return 'Vorbereiten';
                    break;
                    case "Prepare for your doctor’s appointment":
                        return 'Bereite dich auf den Arzttermin vor';
                    break;
                    case "Schedule your doctor's appointment":
                        return 'Plane deinen Arzttermin';
                    break;
                    case "Maximise your appointment":
                        return 'Mach das Beste aus deinem Arzttermin';
                    break;
                    case "You may like to ":
                        return "Vielleicht möchtest du ";
                    break;
                    case "download your allergy dashboard":
                        return "deinen Allergiebericht herunterladen";
                    break;
                    case " to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works.":
                        return ', um ihn mit deiner Ärztin oder deinem Arzt zu besprechen. Am besten hältst du deine Symptome schon vor dem Termin für 3 bis 4 Wochen in einem Allergie-Tagebuch fest. Du kannst das Tagebuch auch nach dem erfolgten Arzttermin für eine anschließende Kontrolle nutzen. So kannst du herausfinden, ob deine aktuelle Behandlung gut wirkt.';
                    break;
                    case "Monitor":
                        return 'Beobachten';
                    break;
                    case "Reassess your symptoms":
                        return 'Behalte deine Symptome im Blick';
                    break;
                    case "Are your symptoms under control?":
                        return 'Hast du deine Symptome im Griff?';
                    break;
                    case "Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ":
                        return 'Bestehende Allergien können sich im Laufe der Zeit verändern und es können neue Allergien hinzukommen. Achte deshalb darauf, wie du dich fühlst. Wenn du Veränderungen bemerkst oder das Gefühl hast, die Kontrolle über deine Symptome zu verlieren, solltest du deine Ärztin oder deinen Arzt aufsuchen, um deine Behandlung zu optimieren. Das ';
                    break;
                    case "allergy diary":
                        return 'Allergie-Tagebuch';
                    break;
                    case " can help you keep track of your symptoms.":
                        return ' hilft dir dabei, deine Symptome besser im Blick zu behalten.';
                    break;
                    case "You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.":
                        return 'Du erhältst in Kürze eine Bestätigungs-E-Mail. Bitte klicke auf den Link in der E-Mail, damit wir wissen, dass du es bist. Dann schicken wir dir den Bericht.';
                    break;
                    case "Your report has been sent now. Thank you for doing the Quick Allergy Check.":
                        return 'Der Allergie-Aktionsplan wurde jetzt abgeschickt. Wir hoffen, dass er dir hilft, deine Allergie in den Griff zu bekommen.';
                    break;
                    case "Allergy diagnosis confirmed by a doctor":
                        return 'Allergiediagnose durch eine Ärztin oder einen Arzt';
                    break;
                    case "Symptom overview":
                        return 'Symptomübersicht';
                    break;
                    case "Tiredness or sleep disruptions":
                        return 'Müdigkeit und Schlafstörungen';
                    break;  
                    case "The VAS for allergic rhinitis (nose symptoms) and allergic conjunctivitis (eye symptoms) adapted from: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.":
                        return 'Die VAS-Skala für allergische Rhinitis (Nasensymptome) und allergische Konjunktivitis (Augensymptome) basiert auf: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.';
                    break;
                    case "Breathing issues":
                        return 'Atembeschwerden';
                    break;
                    case "When symptoms are worse":
                        return 'Wann die Symptome am stärksten sind';
                    break;
                    case "Suspected triggers":
                        return 'Vermutete Auslöser';
                    break;
                    case "Allergic conditions in my family":
                        return 'Allergische Erkrankungen in meiner Familie';
                    break;
                    case "I have or used to have":
                        return 'Ich habe oder hatte früher';
                    break;
                    case "Diagnosed allergies":
                        return 'Diagnostizierte Allergien';
                    break;
                    case "Symptom control":
                        return 'Symptomkontrolle';
                    break;
                    case "IN CONTROL OF ALLERGY SYMPTOMS":
                        return 'ALLERGIESYMPTOME IM GRIFF';
                    break;
                    case "Allergy treatments I'm aware of":
                        return 'Allergiebehandlungen, die ich kenne';
                    break;
                    case "Short-term symptom relief":
                        return 'Kurzzeitige Symptomlinderung';
                    break;
                    case "Allergy immunotherapy":
                        return 'Allergie-Immuntherapie';
                    break;
                    case "Impacted by allergies":
                        return 'Durch Allergien beeinträchtigt';
                    break;
                    case "Save Result":
                        return 'Meine Ergebnisse speichern';
                    break;
                    case "My allergy dashboard":
                        return 'Mein Allergiebericht';
                    break;
                }

            } catch (e) {
                console.error(e);
            }
        }
    }
    var getTranslationUtility = new getTranslationUtilities();

    window.webOnBoarding = {
        commonQuestions: [
            {
                question: getTranslationUtility.getTranslation('Are you taking this quiz for yourself or for your child?'),
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Myself'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('My child'),
                    }
                ]
            },
            {
                question: getTranslationUtility.getTranslation('What are your goals in exploring allergies?'),
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Find out more about allergies in general'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Determine if I might have an allergy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Understand allergy treatments'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Prepare for a doctor’s appointment'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Make allergy management easier'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Something else'),
                        disable: true,
                    }
                ]
            },
            {
                question: getTranslationUtility.getTranslation('Have your allergies been diagnosed by a doctor?'),
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Yes'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('No'),
                    }
                ]
            }
        ],
        diagnosedQuestions: [
            {
                question: getTranslationUtility.getTranslation('What allergies have you been diagnosed with?'),
                category: '',
                questionType: 3,
                subMultipleOptionsCategory: getTranslationUtility.getTranslation('Pollen'),
                subMultipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Grass')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Tree')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Weed')
                    }
                ],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Dust mite'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Animals'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Certain foods'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Insect stings'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Other'),
                        disable: true,
                    }
                ],
                logoImage: '',
            },
            {
                question: getTranslationUtility.getTranslation('How are your eyes affected?'),
                category: getTranslationUtility.getTranslation('Eyes'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Watery'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Red'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_1_eye_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('How is your nose affected?'),
                category: getTranslationUtility.getTranslation('Nose'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Stuffy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Runny'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Sneezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_2_nose_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('How are your sleep and energy levels affected?'),
                category: getTranslationUtility.getTranslation('Tiredness'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_4_tiredness_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Do you have any of these breathing issues?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Coughing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Tight chest'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Wheezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('None'),
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Do you feel in control of your symptoms?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Yes'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('No'),
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Which allergy treatments are you aware of?'),
                category: '',
                questionType: 4,
                subMultipleOptionsCategory: getTranslationUtility.getTranslation('Symptomatic medicine such as antihistamines or corticosteroids'),
                subMultipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Tablets/capsules')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Syrup')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Nasal spray')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Eye drops')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Inhaler')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Creams or lotions')
                    }
                ],
                subMultipleOptionsCategory2: getTranslationUtility.getTranslation('Allergy immunotherapy'),
                subMultipleOptions2: [
                    {
                        title: getTranslationUtility.getTranslation('Tablets'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Drops'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Shots'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Other1'),
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Which aspects of your life are affected?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Sleep'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Family routines'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Concentration at school/work'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Sports'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Other1'),
                        disable: true,
                    }
                ],
                logoImage: ''
            }
        ],
        unDiagnosedQuestions: [
            {
                question: getTranslationUtility.getTranslation('How are your eyes affected?'),
                category: getTranslationUtility.getTranslation('Eyes'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Watery'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Red'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_1_eye_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('How is your nose affected?'),
                category: getTranslationUtility.getTranslation('Nose'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Stuffy'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Runny'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Sneezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Itchy'),
                    }
                ],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_2_nose_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('How are your sleep and energy levels affected?'),
                category: getTranslationUtility.getTranslation('Tiredness'),
                questionType: 2,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [],
                logoImage: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_Test_step_4_tiredness_top_icon_blue.svg'
            },
            {
                question: getTranslationUtility.getTranslation('Do you have any of these breathing issues?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Coughing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Tight chest'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Wheezing'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('None'),
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('When are your symptoms worse?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Spring'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Summer'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Fall'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Winter'),
                        attribute: 'season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('All year round'),
                        attribute: 'all season',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Indoors'),
                        attribute: '',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Outdoors'),
                        attribute: '',
                    },
                    {
                        title: getTranslationUtility.getTranslation('Don’t know'),
                        disable: true,
                        attribute: '',
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Any idea what triggers your symptoms?'),
                category: '',
                questionType: 3,
                subMultipleOptionsCategory: getTranslationUtility.getTranslation('Pollen'),
                subMultipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Grass')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Tree')
                    },
                    {
                        title: getTranslationUtility.getTranslation('Weed')
                    }
                ],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Dust mite'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Animals'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Certain foods'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Insect stings'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Other/Don’t know'),
                        disable: true,
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Does anyone in your family have allergic conditions, such as hay fever, asthma, hives or rashes?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Yes'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Don’t know'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('No'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Skip'),
                    }
                ],
                logoImage: ''
            },
            {
                question: getTranslationUtility.getTranslation('Have you ever had these conditions?'),
                category: '',
                questionType: 1,
                subMultipleOptionsCategory: '',
                subMultipleOptions: [],
                subMultipleOptionsCategory2: '',
                subMultipleOptions2: [],
                multipleOptions: [
                    {
                        title: getTranslationUtility.getTranslation('Eczema'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Asthma'),
                    },
                    {
                        title: getTranslationUtility.getTranslation('Not affected'),
                        disable: true,
                    }
                ],
                logoImage: ''
            }
        ],
        answers: [
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            },
            {
                question: '',
                options: [],
                subQuestion: '',
                subOptions: [],
                subQuestion2: '',
                subOptions2: [],
                category: '',
                vas_score: null
            }
        ],
        indicatorImages: [
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_green_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_orange_blob_test.svg',
            'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_red_blob_test.svg',
        ],
        highestVASScore: 0,
        typeOfQuestion: '',
        typeOfQuiz: '',
        highestVASCategory: [],
        imageCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
        highestVASColor: '#009DC1',
        currentQuestion: 1,
        nextQuestion: 2,
        previousQuestion: 0,
        currentStep: 'step-1',
        WOBQuizContainer: document.querySelector('[data-wob-quiz]'),
        QACIntroSlider: document.querySelector('[data-qac-intro-slider]'),
        commonQuestionsContainer: document.querySelector('#common-questions'),
        diagnosedQuestionsContainer: document.querySelector('#diagnosed-questions'),
        unDiagnosedQuestionsContainer: document.querySelector('#unDiagnosed-questions'),
        isDiagnosedOrNot: true,
        indicatorPopUp: document.querySelector('.indicator-value-overlay'),
        introSlide: document.querySelector('.quiz-background-color .intro-slide'),
        questionSlide: document.querySelector('.quiz-background-color .question-slide'),
        signupForms: [document.querySelector('#wob-braze-form-main form'), document.querySelector('#wob-braze-form-popup-main form')],
        closeQuizPopup: document.querySelector('[data-close-quiz-popup]'),
        closeQuizResultPopup: document.querySelector('[data-close-quiz-result-popup]'),
        resultContainer: document.querySelector('#step-result'),
        quizContainer: document.querySelector('.quiz-background-color'),
        resultTitle: '',
        resultMessage: '',
        knownUser: false,
        newsletterSignupVal: 'off',
        wob_stage: '',

        init() {
            // console.log("Button for result", document.querySelector('.block-result .result-button-container button'));
            this.setHTML();

            if (Utility.getCookie('WOBID_Cookie') != '' && Utility.getCookie('WOBID_Cookie') != null && Utility.getCookie('WOBID_Cookie') != 'WOBID_Cookie') {
                this.knownUser = true;
                document.querySelectorAll('.braze-form-container.form .newsletter_signup_checkbox').forEach(newsletterSignupCheckbox => {
                    newsletterSignupCheckbox.classList.add('d-none');
                }); 
                // document.querySelector('.brazeFormContainer.result').classList.remove('d-none');
                // document.querySelector('.brazeFormContainer.signup').classList.add('d-none');
            }
            else {
                this.knownUser = false;
            }

            document.querySelector('#start-quiz').addEventListener('click', (e) => {
                this.introSlide.classList.add('d-none');
                this.questionSlide.classList.remove('d-none');
                window.dataLayer.push({
                    'event': 'wob_started'
                });
            });
            document.querySelector('#qac-start-quiz').addEventListener('click', (e) => {
                window.location.href = "https://allergiecheck.de/pages/allergie-schnellcheck";
                window.dataLayer.push({
                    'event': 'web_wob_to_qac'
                });
            });
            document.querySelectorAll('.scale-container .indicator-popup-text-container').forEach(indicatorpopupText => {
                indicatorpopupText.addEventListener('click', () => {
                    this.indicatorPopUp.classList.remove('d-none');
                })
            });
            this.indicatorPopUp.querySelector('.navigation-icon').addEventListener('click', () => {
                this.indicatorPopUp.classList.add('d-none');
            });

            document.querySelectorAll('[data-question-close]').forEach(questionClose => {
                questionClose.addEventListener('click', ()=>{
                    this.closeQuizPopup.classList.remove('d-none');
                });
            });
        
            document.querySelector('[data-intro-close]').addEventListener('click', () =>{
                this.closeQuizPopup.classList.remove('d-none');
            });

            document.querySelector('.quiz-question-popup .yes-btn').addEventListener('click', () =>{
                window.location.href = "/pages/allergie-aktionsplan";
            });

            document.querySelector('.quiz-question-popup .close-navigation-btn').addEventListener('click', () =>{
                this.closeQuizPopup.classList.add('d-none');
            });

            document.querySelector('.quiz-question-popup .no-btn').addEventListener('click', () =>{
                this.closeQuizPopup.classList.add('d-none');
            });

            document.querySelector('.quiz-result-popup .yes-btn').addEventListener('click', (e) =>{
                let dataUrl = e.target.getAttribute('data-url');
                window.location.href = dataUrl;
            });

            document.querySelector('.braze-form-popup.quiz-popup-overlay .close-navigation-btn').addEventListener('click', ()=>{
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.add('d-none');
            })

            document.querySelector('.quiz-result-popup .no-btn').addEventListener('click', () =>{
                // form popup active
            });

            document.querySelector('[data-result-close]').addEventListener('click', ()=>{
                this.closeQuizResultPopup.classList.remove('d-none');
            });

            document.querySelector('.quiz-result-popup .close-navigation-btn').addEventListener('click', () =>{
                this.closeQuizResultPopup.classList.add('d-none');
            });

            this.closeQuizResultPopup.querySelector('button.no-btn').addEventListener('click', ()=>{
                console.log("Opening the braze popup form",  document.querySelector('#wob-braze-form-popup-main'))
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.remove('d-none');
                this.closeQuizResultPopup.classList.add('d-none');
            })

            // document.querySelectorAll('input[type="range"]').forEach(slider => {
            //     slider.addEventListener('change', (e) => {
            //         let parentElement = e.currentTarget.closest('.scale-container');
            //         let imageElement = parentElement.querySelector('img');
            //         if (e.currentTarget.value == 0) {

            //             imageElement.src = this.indicatorImages[0];
            //         }
            //         if (e.currentTarget.value == 1) {

            //             imageElement.src = this.indicatorImages[1];
            //         }
            //         if (e.currentTarget.value < 5 && e.currentTarget.value > 1) {
            //             imageElement.src = this.indicatorImages[2];
            //         }
            //         if (e.currentTarget.value > 4) {
            //             imageElement.src = this.indicatorImages[3];
            //         }
            //     })
            // });

            //to select only one option for question 1 and question 3
            document.querySelectorAll(`.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"], .question-answer#step-3-questionContainer input[type="checkbox"], 
            [data-question-collection="diagnosed"] .question-answer#step-9-questionContainer input[type="checkbox"], [data-question-collection="unDiagnosed"] 
            .question-answer#step-10-questionContainer input[type="checkbox"]`).forEach(input => {
                // console.log("input of single selection", input);
                let inputParent = input.closest('.dynamicQuestion');
                let inputParentParameter = inputParent.getAttribute('id');
                let inputParentParameterString = inputParentParameter.split("-");
                let inputParentID = inputParentParameterString[1];
                let inputs;
                if (inputParentID == 1) {
                    inputs = document.querySelectorAll(`.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]`);
                }
                else if (inputParentID == 3) {
                    inputs = document.querySelectorAll(`.question-answer#step-3-questionContainer input[type="checkbox"]`);
                }
                else if (inputParentID == 9) {
                    inputs = document.querySelectorAll(`[data-question-collection="diagnosed"] .question-answer#step-9-questionContainer input[type="checkbox"]`);
                }
                else if (inputParentID == 10) {
                    inputs = document.querySelectorAll(`[data-question-collection="unDiagnosed"] .question-answer#step-10-questionContainer input[type="checkbox"]`);
                }
                input.addEventListener('change', (e) => {
                    if (input.checked) {
                        inputs.forEach(otherCheckbox => {
                            if (otherCheckbox !== input) {
                                otherCheckbox.checked = false;
                            }
                        });
                    }
                });
            });
            //change event for input of questions
            // document.querySelectorAll('.dynamicQuestion input[type=checkbox], .main-answer-container input[type=checkbox]').forEach(checkbox => {
            document.querySelectorAll('.main-answer-container input[type=checkbox]').forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    let currentQuestion = e.currentTarget.closest('.dynamicQuestion');
                    if (!currentQuestion.classList.contains('d-none')) {
                        let allCheckedChecboxes = currentQuestion.querySelectorAll('input[type="checkbox"]:checked');
                        let btn = currentQuestion.querySelector('.right-navigation-button-container');
                        if (allCheckedChecboxes.length > 0) {
                            btn.disabled = false;
                        }
                        else {
                            btn.disabled = true;
                        }
                    }
                })
            })
            //to close the QAC intro slide
            document.querySelector('[data-qac-intro-slider] .navigation-container .left-navigation-button-container').addEventListener('click', () => {
                this.QACIntroSlider.classList.add('d-none');
                this.WOBQuizContainer.classList.remove('d-none');
                let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
                for (let i = 0; i < stepElements.length; i++) {
                    stepElements[i].classList.remove('completed');
                    stepElements[i].classList.remove('active');
                    if (i == 0) {
                        stepElements[i].classList.add('active');
                    }
                }
            });

            //to navigate to next question for common question
            document.querySelectorAll('.dynamicQuestion .right-navigation-button-container').forEach(navigationBtnEl => {
                navigationBtnEl.addEventListener('click', (e) => {
                    let nextQuestion = navigationBtnEl.getAttribute('data-next-step');
                    let currentQuestion = navigationBtnEl.closest('.dynamicQuestion');
                    this.getAnswer(e);
                    //to open the QAC intro slide
                    var consent = document.querySelector('input[name="user_consent"]');
                    if(nextQuestion != 'step-result') {
                        if (navigationBtnEl == document.querySelector('.dynamicQuestion#step-1 .right-navigation-button-container')) {
                            // console.log("Inside first question next");
                            let input = document.querySelector('.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]:checked');
                            if (input.value == getTranslationUtility.getTranslation('Myself')) {
                                // console.log("Inside myself");
                                if (consent && consent.checked) {
                                    this.typeOfQuestion = 'WOB';
                                    document.querySelector(`.dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                                    currentQuestion.classList.add('d-none');

                                    window.dataLayer.push({
                                        'event': 'wob_started_consent_yes'
                                    });
                                }
                                else {
                                    var wrapper = document.querySelector('.consent_checkbox_wrapper');
                                    if (wrapper) {
                                        wrapper.classList.add('required');
                                        setTimeout(function () {
                                            wrapper.classList.remove('required');
                                        }, 2000);
                                        
                                        window.dataLayer.push({
                                            'event': 'wob_started_consent_no'
                                        });
                                    }
                                }
                            }
                            else {
                                // console.log("Inside my child");
                                this.typeOfQuestion = 'QAC';
                                this.QACIntroSlider.classList.remove('d-none');
                                this.WOBQuizContainer.classList.add('d-none');
                            }
                        }
                        else if (navigationBtnEl == document.querySelector('.dynamicQuestion#step-3 .right-navigation-button-container')) {
                            // console.log("Inside third question next");
                            let input = document.querySelector('.question-answer#step-3-questionContainer input[type="checkbox"]:checked');
                            if (input.value == getTranslationUtility.getTranslation('Yes')) {
                                this.diagnosedQuestionsContainer.classList.remove('d-none');
                                document.querySelector(`#diagnosed-questions .dynamicQuestion#step-4`).classList.remove('d-none');
                                this.commonQuestionsContainer.classList.add('d-none');
                            }
                            else {
                                this.isDiagnosedOrNot = false;
                                this.unDiagnosedQuestionsContainer.classList.remove('d-none');
                                document.querySelector(`#unDiagnosed-questions .dynamicQuestion#step-4`).classList.remove('d-none');
                                this.commonQuestionsContainer.classList.add('d-none');
                            }
                        }
                        else {
                            // console.log("Inside other question next",nextQuestion);
                            let questionType = '#common-questions';
                            let stringNextQuestion = nextQuestion.split("-");
                            let numericNextQuestion = parseInt(stringNextQuestion[1]);
                            if(numericNextQuestion>3 && this.isDiagnosedOrNot) {
                                questionType = '#diagnosed-questions';
                            }
                            else if (numericNextQuestion>3 && !this.isDiagnosedOrNot) {
                                questionType = '#unDiagnosed-questions';
                            }

                            // vas score slider/checkbox pulsing logic start 
                            if (e.currentTarget.classList.contains("soft-disabled")) {
                                let stepContainer = e.currentTarget.closest('.dynamicQuestion');
                                let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                                let rangeInput = stepContainer.querySelector('input[type="range"]');
                                let rangeValue = rangeInput ? Number(rangeInput.value) : 0;
                                let optionsContainer = stepContainer.querySelector('.symptoms-option-container');
                                let scaleContainer = stepContainer.querySelector('.scale-container');
                                   
                                if (checkedBoxes > 0 && rangeValue === 0) {
                                    this.pulseElement(scaleContainer);
                                }
                                if (checkedBoxes === 0 && rangeValue > 0) {
                                    this.pulseElement(optionsContainer);
                                }
                                e.preventDefault();
                                return false;
                            }
                            // vas score slider/checkbox pulsing logic end
                            
                            document.querySelector(`${questionType} .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                            currentQuestion.classList.add('d-none');
                        }
                        
                    }
                    else {
                        this.resultContainer.classList.remove('d-none');
                        this.quizContainer.classList.add('d-none');
                        // this.sendAnswer();
                        // this.getBiggestIndicatorValue();
                        this.createSummaryHTMLSteps();
                        this.createSummaryHTML();

                        window.dataLayer.push({
                            'event': 'wob_completed',
                            persona: 'adult',
                            cj_stage: 'ready_for_action',
                            allergy_type_trees: localStorage.getItem('pageviewTree') == 'true' ? 'yes' : 'no',
                            allergy_type_grasses: localStorage.getItem('pageviewGrass') == 'true' ? 'yes' : 'no',
                            allergy_type_weeds: localStorage.getItem('pageviewWeed') == 'true' ? 'yes' : 'no',
                            allergy_type_mites: localStorage.getItem('pageviewMite') == 'true' ? 'yes' : 'no',
                            allergy_type_venom: localStorage.getItem('pageviewVenom') == 'true' ? 'yes' : 'no',
                        });

                        this.signupForms.forEach(signupForm =>{
                            var webStageElement = document.createElement('input');
                            webStageElement.setAttribute('name', 'web_stage');
                            webStageElement.setAttribute('value', this.wob_stage);
                            webStageElement.setAttribute('readonly', '');
                            webStageElement.setAttribute('type', 'hidden');
                            signupForm.querySelector('.submitBtnContainer').before(webStageElement);
                        });
                    }

                    if(document.querySelector('.question-answer#step-1-questionContainer [data-option-type="multiCheckboxes"] input[type="checkbox"]:checked').value != getTranslationUtility.getTranslation('My child')) {
                        if (consent && consent.checked) {
                            this.currentStep = nextQuestion;
                            let newString = nextQuestion.split("-");
                            this.currentQuestion = newString[1];
                            this.nextQuestion = parseInt(newString[1]) + 1;
                        }
                    }
                    
                    let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
                    if (consent && consent.checked) {
                        for (let i = 0; i < stepElements.length; i++) {
                            stepElements[i].classList.remove('completed');
                            stepElements[i].classList.remove('active');
                            if (i <= [this.currentQuestion - 2]) {
                                stepElements[i].classList.add('completed');
                            }
                        }
                        if (nextQuestion != 'step-result') {
                            stepElements[this.currentQuestion - 1].classList.add('active');
                        }
                    }
                });
            });

            //to navigate to previous question for common question
            document.querySelectorAll('.dynamicQuestion .left-navigation-button-container').forEach(navigationBtnEl => {
                navigationBtnEl.addEventListener('click', () => {
                    // console.log("navigationBtnEl", navigationBtnEl);
                    let nextQuestion = navigationBtnEl.getAttribute('data-previous-step');
                    let currentQuestion = navigationBtnEl.closest('.dynamicQuestion');
                    let questionType = '#common-questions';
                    let stringNextQuestion = nextQuestion.split("-");
                    let numericNextQuestion = parseInt(stringNextQuestion[1]);
                    if(numericNextQuestion>2 && this.isDiagnosedOrNot) {
                        questionType = '#diagnosed-questions';
                    }
                    else if (numericNextQuestion>2 && !this.isDiagnosedOrNot) {
                        questionType = '#unDiagnosed-questions';
                    }
                    if (navigationBtnEl != document.querySelector(`${questionType} .dynamicQuestion#step-4 .left-navigation-button-container`)) {
                        // console.log("Inside if of not equal", navigationBtnEl.closest('.dynamicQuestion'));
                        document.querySelector(`${questionType} .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                        currentQuestion.classList.add('d-none');
                    }
                    else {
                        // console.log("Inside else of being equal")
                        this.commonQuestionsContainer.classList.remove('d-none');
                        if(this.isDiagnosedOrNot) {
                            this.diagnosedQuestionsContainer.classList.add('d-none');
                        }
                        else {
                            this.unDiagnosedQuestionsContainer.classList.add('d-none');
                        }
                        currentQuestion.classList.add('d-none');
                        document.querySelector(`#common-questions .dynamicQuestion#${nextQuestion}`).classList.remove('d-none');
                    }
                    this.currentStep = nextQuestion;
                    let newString = nextQuestion.split("-");
                    this.currentQuestion = newString[1];
                    this.previousQuestion = parseInt(newString[1]) - 1;
                    let stepElements = document.querySelectorAll('[data-wob-quiz] .description-container .pagination .step');
                    for (let i = 0; i < stepElements.length; i++) {
                        stepElements[i].classList.remove('completed');
                        stepElements[i].classList.remove('active');
                        if (i <= [this.currentQuestion - 2]) {
                            stepElements[i].classList.add('completed');
                        }
                    }
                    if (nextQuestion != 'step-result') {
                        stepElements[this.currentQuestion - 1].classList.add('active');
                    }
                });
            });

            // consent box hide/show
            var radioInputs = document.querySelectorAll('#step-1-questionContainer input[name="common-0"]');
            var consentSection = document.querySelector('[data-consent-section]');
            radioInputs.forEach(function (radio) {
                radio.addEventListener('change', function () {
                    var selected = document.querySelector('#step-1-questionContainer input[name="common-0"]:checked');
                    if (selected && selected.value === getTranslationUtility.getTranslation('My child')) {
                        if (consentSection) consentSection.classList.add('d-none');
                    } else {
                        if (consentSection) consentSection.classList.remove('d-none');
                    }
                });
            });

            //if none option is selected
            document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', (e) => {
                    let inputName = e.currentTarget.name;
                    // console.log("inputName", inputName);
                    if (inputName != null) {
                        let currentQuestionCheckboxes = document.querySelectorAll(`input[name="${inputName}"]`);
                        if (e.currentTarget.hasAttribute("data-none-option")) {
                            if (e.currentTarget.checked) {
                                currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                                    if (!currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                        currentQuestionCheckbox.checked = false
                                    }
                                });
                            }
                        }
                        else {
                            currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                                if (currentQuestionCheckbox.hasAttribute("data-none-option")) {
                                    currentQuestionCheckbox.checked = false;
                                }
                            });
                        }
                    }
                });
            });

            //seasons option selection
            document.querySelectorAll('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer  input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', () => {
                    if (checkbox.hasAttribute('data-attribute')) {

                        let dataAttributeValue = checkbox.getAttribute('data-attribute')
                        if (dataAttributeValue == "all season") {
                            document.querySelectorAll('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer input[type="checkbox"][data-attribute="season"]').forEach(otherCheckbox => {
                                otherCheckbox.checked = false;
                            })
                        }
                        else {
                            document.querySelector('[data-question-collection="unDiagnosed"] .question-answer#step-8-questionContainer input[type="checkbox"][data-attribute="all season"]').checked = false;
                        }
                    }
                });
            });

            // fad popup close
            document.querySelector('.result-fad-widget-popup .close-navigation-btn').addEventListener('click', (e) => {
                document.querySelector('.result-fad-widget-popup').classList.remove('active');
                document.querySelector('#steps-pagination .step.active').classList.remove('active');
            });

            //braze form submission
            this.signupForms.forEach(signupForm =>{
                // console.log("for loop signupForm", signupForm)
                signupForm.querySelector('button').addEventListener('click', async (event) => {
                    event.preventDefault();
                    console.log("signupForm", signupForm);
                    let nameInput = signupForm.querySelector('input[name="first_name"]');
                    let emailInput = signupForm.querySelector('input[name="email"]');
                    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    let verifiedEmail = emailInput.value.match(emailPattern);
                    let consentBox = signupForm.querySelector('input[data-consent-checkbox]');
                    let inputs = [emailInput];
                    let emailValue = emailInput.value;
                    inputs.forEach(input =>{
                        input.addEventListener('blur', () =>{
                            if(input.classList.contains('required') && input.value != null) {
                                input.classList.remove('required');
                            }
                        })
                    })
                    console.log("nameInput, emailInput, consentBox, consentBox.checked", nameInput,emailInput,consentBox, consentBox.checked )
                    if(verifiedEmail == null) {
                        emailInput.classList.add('required');
                    }
                    if(!consentBox.checked) {
                        let parent = consentBox.closest('.checkbox-label');
                        let checkMark = parent.querySelector('.custom-checkmark');
                        checkMark.classList.add('required');
                    }
                    if(verifiedEmail && consentBox.checked) {
                        let formData = new FormData(signupForm);
                        formData.append(
                            'existing_external_id',
                            md5(emailValue)
                        )
                        const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                            method: "POST",
                            body: formData,
                        });
                        const res = await response.json();
                        if (response.status == 200) {
                            if(res.data.attributes[0].external_id != '') {
                                if (typeof braze !== 'undefined') {
                                    //braze sdk is loaded and we can tun the changeUser function
                                    braze.changeUser(this.responseText);
                                }
                                if (typeof appboy !== 'undefined') {
                                    //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                                    appboy.changeUser(this.responseText);
                                }
                                if (Utility.getCookie('BUID_Cookie') == '' || Utility.getCookie('BUID_Cookie') == undefined) {
                                    Utility.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                                    
                                }
                                Utility.setCookie('WOBID_Cookie', res.data.attributes[0].external_id);
                                Utility.setCookie('WOB_email', emailValue);

                                let thankyouText = '';
                                if(this.knownUser){
                                    thankyouText = getTranslationUtility.getTranslation("Your report has been sent now. Thank you for doing the Quick Allergy Check.");
                                }
                                else {
                                    let newsletterSignup = signupForm.querySelector('input[name="newsletter_signup"]');
                                    if(newsletterSignup.checked) {
                                        thankyouText = getTranslationUtility.getTranslation("You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.");
                                        document.querySelectorAll('.braze-form-container.result .resultMessage').forEach(resultMessage => {
                                            resultMessage.classList.remove('d-none');
                                        }); 
                                        this.newsletterSignupVal = 'on';
                                    }
                                    else {
                                        thankyouText = getTranslationUtility.getTranslation("Your report has been sent now. Thank you for doing the Quick Allergy Check.");
                                        this.newsletterSignupVal = 'off';
                                    }
                                }
                                
                                let forms = document.querySelectorAll('.braze-form-container.form');
                                let formResults = document.querySelectorAll('.braze-form-container.result');

                                forms.forEach(form =>{
                                    form.classList.add('d-none');
                                });
                                formResults.forEach(formResult =>{
                                    formResult.querySelector('.description').innerHTML = thankyouText;
                                    formResult.classList.remove('d-none');
                                });
                                
                                document.querySelectorAll('.braze-form-container.form input[type="checkbox"]').forEach(formCheckboxes => {
                                    formCheckboxes.checked = false;
                                }); 
                                document.querySelectorAll('.braze-form-container.form input[type="text"], .braze-form-container.form input[type="email"]').forEach(formInputboxes => {
                                    formInputboxes.value = '';
                                });

                                let bodyData = {
                                    "response": this.answers,
                                    "email": emailValue,
                                    "external_id": res.data.attributes[0].external_id,
                                    "result_type": this.isDiagnosedOrNot ? 1 : 2,
                                    "language": 'de',
                                };
                                this.sendAnswer(bodyData);

                                if(document.querySelector('.braze-form-popup').classList.contains('d-none')){
                                    window.dataLayer.push({
                                        'event': 'wob_report_result_signup',
                                        'position': '1'
                                    });
                                }
                                else {
                                    window.dataLayer.push({
                                        'event': 'wob_report_result_signup',
                                        'position': '2'
                                    });
                                }
                            }
                        }
                    }
                });
            });
        },
        setHTML() {
            this.setCommonHTML();
            this.diagnosedQuestionsHTML();
            this.unDiagnosedQuestionsHTML();
        },
        
        pulseElement(el) {
            if (!el) return;
            el.classList.remove('pulse');
            void el.offsetWidth;
            el.classList.add('pulse');
            setTimeout(() => {
                el.classList.remove('pulse');
                void el.offsetWidth;
                el.classList.add('pulse');
                el.addEventListener('animationend', function handler() {
                    el.classList.remove('pulse');
                    el.removeEventListener('animationend', handler);
                });
            }, 300);
        },
        handleStep(stepId) {
            let stepContainer = document.querySelector(stepId);
            
            if (!stepContainer) return;
            let nextBtn = stepContainer.querySelector('.right-navigation-button-container');
            function updateButtonState(e) {
                let checkedBoxes = stepContainer.querySelectorAll('input[type="checkbox"]:checked').length;
                let rangeInput = stepContainer.querySelector('input[type="range"]');
                var rangeValue = Number(stepContainer.querySelector('input[type="range"]').value);
                if (e?.target?.type === 'checkbox' &&
                    !e.target.checked &&
                    checkedBoxes === 0 &&
                    rangeValue !== 0
                ) {
                    rangeInput.value = 0;
                    rangeValue = 0;
                    let characterImg = stepContainer.querySelector('.character img');
                    if (characterImg) {
                        characterImg.src = 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg';
                    }
                    rangeInput.dispatchEvent(new Event('input'));
                }
                let isValid = (checkedBoxes == 0 && rangeValue == 0) || (checkedBoxes > 0 && rangeValue > 0);
                // nextBtn.disabled = !isValid;
                nextBtn.classList.toggle('soft-disabled', !isValid);
                nextBtn.style.opacity = isValid ? '1' : '0.5';
            }
            //stepContainer.addEventListener('change', updateButtonState);
            stepContainer.addEventListener('input', updateButtonState);
        },
            
        setCommonHTML() {
            let questionsHTML = '';
            this.commonQuestions.forEach((question, questionIndex) => {
                let optionsHTML = '';
                question.multipleOptions.forEach((option) => {
                    let optionHTML = `
                    <label class="checkbox-item">
                        <input type="checkbox" name="common-${questionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                        <span class="checkmark"></span>
                        ${option.title}
                    </label>
                        `;
                    optionsHTML += optionHTML;
                });

                let consentHtml = '';
                if(questionIndex == 0) {
                    consentHtml = `
                        <div class="consent_checkbox_wrapper d-none" data-consent-section>
                            <div class="checkbox-container consent_checkbox">
                                <label class="checkbox-label">
                                <input type="checkbox" class="custom-checkbox" name="user_consent" data-consent-checkbox="">
                                <span class="custom-checkmark"></span>
                                <span class="checkbox-text">Ich willige ein, dass allergiecheck (ALK-Abelló A/S) meine personenbezogenen Daten, z. B. Name, falls angegeben, sowie meine Gesundheitsdaten verarbeitet, z. B. Allergiesymptome, die ich im Fragebogen angebe. Ich verstehe, dass dies notwendig ist, um personalisierten Inhalt zu erhalten. Meine Einwilligung kann ich jederzeit widerrufen. Alle Einzelheiten, einschließlich Widerrufsdetails, finden sich in der <a href="/pages/datenschutzerklaerung" target="_blank" class="target_blank semibold">Datenschutzerklärung</a>.*</span>
                                </label>
                            </div>
                            <div class="required-field"><span class="medium">*erforderlich</span></div>
                        </div>
                    `;
                }

                let questionHTML = `
                        <div class="dynamicQuestion ${questionIndex == 0 ? '' : 'd-none'}" id="step-${questionIndex + 1}" data-question-collection="common">
                            <div class="question-answer" id="step-${questionIndex + 1}-questionContainer">
                                <div class="question-answer-container"  data-options-type="multiCheckboxes" data-question-type="checkbox">
                                <h3 class="question col-8 col-sm-4 col-md-4 col-lg-4 text-center mx-auto">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            <div class="two-column checkboxes-container">
                                                ${optionsHTML}
                                            </div>
                                        </div>
                                    </div>
                                    ${consentHtml}
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container ${questionIndex == 0 ? 'invisible' : ''}" data-previous-step="${questionIndex != 0 ? `step-${questionIndex}` : ''}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">${getTranslationUtility.getTranslation('BACK')}</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled data-next-step="step-${questionIndex + 2}">
                                    <span class="button-label">${getTranslationUtility.getTranslation('NEXT')}</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                    </div>
                `;

                questionsHTML += questionHTML;
            });
            this.commonQuestionsContainer.innerHTML = questionsHTML;
        },
        diagnosedQuestionsHTML() {
            let questionsHTML = '';
            this.diagnosedQuestions.forEach((question, questionIndex) => {
                let trueQuestionIndex = questionIndex + 3;
                let questionHTML;
                let optionsHTML = '';
                if (question.questionType == 1) {
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                                ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 3) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item sub-options-checkbox-item">
                            <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    optionHTML = `<div class="subOptionsContainer">
                                    <div class="subOptionsHeader">${question.subMultipleOptionsCategory}:</div>
                                    ${subOptionsHTML}
                                </div>`;
                    optionsHTML = optionHTML;
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                                ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 4) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    let secondSubOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item">
                            <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    question.subMultipleOptions2.forEach((option) => {
                        let secondSubOptionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="2" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        secondSubOptionsHTML += secondSubOptionHTML;
                    });
                    optionHTML = `<div class="second-suboptions-container col-md-8">
                                    <div class="second-suboptions-title">${question.subMultipleOptionsCategory}:</div>
                                    <div class="two-column">
                                        ${subOptionsHTML}
                                    </div>
                                </div>
                                <div class="first-suboptions-container">
                                    <div class="first-suboptions-title">${question.subMultipleOptionsCategory2}:</div>
                                    ${secondSubOptionsHTML}
                                </div>`;

                    optionsHTML += optionHTML;
                    optionsHTML =  `<div class="checkboxes-container d-md-flex">
                                                ${optionsHTML}
                                    </div>`;
                }

                //selecting whether indicator or checkbox slide
                if (question.questionType == 2) {
                    let indicatorOptions = ``;
                    question.multipleOptions.forEach((option) => {
                        let indicatorOption = `
                            <div class="symptoms-option">
                                <label>
                                    <input type="checkbox" name="diagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                    <span>${option.title}</span>
                                </label>
                            </div>
                        `;
                        indicatorOptions += indicatorOption;
                    });

                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="diagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-options-type="indicatorOptions">
                                    <h3 class="question col-8 col-sm-4 col-md-4 col-lg-4 text-center mx-auto">${question.question}</h3>
                                    <div class="answer-container" data-options>
                                        <div class="symptoms-container" data-option-type="indicatorOptions">
                                            <img class="symptoms-image" src="${question.logoImage}" alt="${question.category} logo" />
                                            <div class="symptoms-container-sub">
                                                <div class="symptoms-category">${question.category}</div>
                                                ${indicatorOptions.length > 0 ? `
                                                <div class="symptoms-heading">${getTranslationUtility.getTranslation('Select specific symptoms')}</div>
                                                <div class="symptoms-option-container d-flex">
                                                    ${indicatorOptions}
                                                </div>
                                                ` : ``}
                                            </div>
                                        </div>
                                        <div class="indicator-container">
                                            <div class="indicator-heading">${getTranslationUtility.getTranslation('Rate the overall impact')}</div>
                                            <div class="scale-container mx-auto">
                                                <div class="position-relative">
                                                    <input type="range" min="0" max="10" value="0" class="slider" id="${question.category}" />
                                                    <div class="number-labels"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span> <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span></div>
                                                </div>
                                                <div class="labels">
                                                    <span class="sliderNotAffected indicatorText">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                                    <div class="indicator-popup-text-container">${getTranslationUtility.getTranslation('Understand the scale')}</div>
                                                    <span class="sliderVeryAffected indicatorText">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                        <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">${getTranslationUtility.getTranslation('BACK')}</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" 
                                ${trueQuestionIndex == 10 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 10 ? getTranslationUtility.getTranslation('SUBMIT') : getTranslationUtility.getTranslation('NEXT')}</span>
                                    <span class="button-container right-button-container">
                                        <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }
                else {
                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="diagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-question-type="checkbox" data-options-type="multiCheckboxes">
                                <h3 class="question col-8 col-sm-4 col-md-4 col-lg-4 text-center mx-auto">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            ${optionsHTML}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">${getTranslationUtility.getTranslation('BACK')}</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled ${trueQuestionIndex == 10 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 10 ? getTranslationUtility.getTranslation('SUBMIT') : getTranslationUtility.getTranslation('NEXT')}</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }


                questionsHTML += questionHTML;
            });
            this.diagnosedQuestionsContainer.innerHTML = questionsHTML;
            this.handleStep('#step-5[data-question-collection="diagnosed"]');
            this.handleStep('#step-6[data-question-collection="diagnosed"]');
        },
        unDiagnosedQuestionsHTML() {
            //adding name field to input of options and asking if suboptions walu logic
            //indicator popup walu text inline
            let questionsHTML = '';
            this.unDiagnosedQuestions.forEach((question, questionIndex) => {
                let trueQuestionIndex = questionIndex + 3;
                let questionHTML;
                let optionsHTML = '';
                if (question.questionType == 1) {
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''} 
                                ${option.attribute != '' && option.attribute != undefined ? `data-attribute="${option.attribute}"` : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 3) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item sub-options-checkbox-item">
                            <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    optionHTML = `<div class="subOptionsContainer">
                                    <div class="subOptionsHeader">${question.subMultipleOptionsCategory}:</div>
                                    ${subOptionsHTML}
                                </div>`;
                    optionsHTML = optionHTML;
                    question.multipleOptions.forEach((option) => {
                        let optionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        optionsHTML += optionHTML;
                    });
                    optionsHTML =  `<div class="two-column checkboxes-container">
                                        ${optionsHTML}
                                    </div>`;
                }
                if (question.questionType == 4) {
                    let optionHTML = ''
                    let subOptionsHTML = ''
                    let secondSubOptionsHTML = ''
                    question.subMultipleOptions.forEach((option) => {
                        let subOptionHTML = `
                        <label class="checkbox-item">
                            <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="1" ${option.disable == true ? 'data-none-option="true"' : ''}>
                            <span class="checkmark"></span>
                            ${option.title}
                        </label>
                            `;
                        subOptionsHTML += subOptionHTML;
                    });
                    question.subMultipleOptions2.forEach((option) => {
                        let secondSubOptionHTML = `
                            <label class="checkbox-item">
                                <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" data-suboption="2" ${option.disable == true ? 'data-none-option="true"' : ''}>
                                <span class="checkmark"></span>
                                ${option.title}
                            </label>
                            `;
                        secondSubOptionsHTML += secondSubOptionHTML;
                    });
                    optionHTML = `<div class="second-suboptions-container col-md-8">
                                    <div class="second-suboptions-title">${question.subMultipleOptionsCategory}:</div>
                                    <div class="two-column">
                                        ${subOptionsHTML}
                                    </div>
                                </div>
                                <div class="first-suboptions-container">
                                    <div class="first-suboptions-title">${question.subMultipleOptionsCategory2}:</div>
                                    ${secondSubOptionsHTML}
                                </div>`;

                    optionsHTML += optionHTML;
                    optionsHTML =  `<div class="checkboxes-container d-md-flex">
                                        ${optionsHTML}
                                    </div>`;
                }

                //selecting whether indicator or checkbox slide
                if (question.questionType == 2) {
                    let indicatorOptions = ``;
                    question.multipleOptions.forEach((option) => {
                        let indicatorOption = `
                            <div class="symptoms-option">
                                <label>
                                    <input type="checkbox" name="undiagnosed-${trueQuestionIndex}" value="${option.title}" ${option.disable == true ? 'data-none-option="true"' : ''} 
                                    ${option.attribute != '' && option.attribute != undefined ? `data-attribute="${option.attribute}"` : ''}>
                                    <span>${option.title}</span>
                                </label>
                            </div>
                        `;
                        indicatorOptions += indicatorOption;
                    });

                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="unDiagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-options-type="indicatorOptions">
                                    <h3 class="question col-8 col-sm-4 col-md-4 col-lg-4 text-center mx-auto">${question.question}</h3>
                                    <div class="answer-container" data-options>
                                        <div class="symptoms-container" data-option-type="indicatorOptions">
                                            <img class="symptoms-image" src="${question.logoImage}" alt="${question.category} logo" />
                                            <div class="symptoms-container-sub">
                                                <div class="symptoms-category">${question.category}</div>
                                                ${indicatorOptions.length > 0 ? `
                                                <div class="symptoms-heading">${getTranslationUtility.getTranslation('Select specific symptoms')}</div>
                                                <div class="symptoms-option-container d-flex">
                                                    ${indicatorOptions}
                                                </div>
                                                ` : ``}
                                            </div>
                                        </div>
                                        <div class="indicator-container">
                                            <div class="indicator-heading">${getTranslationUtility.getTranslation('Rate the overall impact')}</div>
                                            <div class="scale-container mx-auto">
                                                <div class="position-relative">
                                                    <input type="range" min="0" max="10" value="0" class="slider" id="${question.category}" />
                                                    <div class="number-labels"><span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span> <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span></div>
                                                </div>
                                                <div class="labels">
                                                    <span class="sliderNotAffected indicatorText">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                                    <div class="indicator-popup-text-container">${getTranslationUtility.getTranslation('Understand the scale')}</div>
                                                    <span class="sliderVeryAffected indicatorText">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                        <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">${getTranslationUtility.getTranslation('BACK')}</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" 
                                ${trueQuestionIndex == 10 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 10 ? getTranslationUtility.getTranslation('SUBMIT') : getTranslationUtility.getTranslation('NEXT')}</span>
                                    <span class="button-container right-button-container">
                                        <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }
                else {
                    questionHTML = `
                        <div class="dynamicQuestion ${trueQuestionIndex == 3 ? '' : 'd-none'}" id="step-${trueQuestionIndex + 1}" data-question-collection="unDiagnosed">
                            <div class="question-answer" id="step-${trueQuestionIndex + 1}-questionContainer">
                                <div class="question-answer-container" data-question-type="checkbox" data-options-type="multiCheckboxes">
                                <h3 class="question col-8 col-sm-4 col-md-4 col-lg-4 text-center mx-auto">${question.question}</h3>
                                <div class="main-answer-container mx-auto">
                                    <div class="answer-container" data-options>
                                        <div data-option-type="multiCheckboxes" class="d-md-flex">
                                            ${optionsHTML}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            <div class="navigation-container d-flex">
                                <button class="align-items-center d-flex left-navigation-button-container" data-previous-step="step-${trueQuestionIndex}">
                                    <span class="button-container left-button-container">
                                    <span class="icon-Group-3429-2 transform-180 arrow-glide-animation"></span>
                                    </span>
                                    <span class="button-label">${getTranslationUtility.getTranslation('BACK')}</span>
                                </button>
                                <button class="align-items-center d-flex right-navigation-button-container" disabled ${trueQuestionIndex == 10 ? `data-next-step="step-result"` : `data-next-step="step-${trueQuestionIndex + 2}"`}>
                                    <span class="button-label">${trueQuestionIndex == 10 ? getTranslationUtility.getTranslation('SUBMIT') : getTranslationUtility.getTranslation('NEXT')}</span>
                                    <span class="button-container right-button-container">
                                    <span class="icon-Group-3429-2 arrow-glide-animation"></span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    `;
                }


                questionsHTML += questionHTML;
            });
            this.unDiagnosedQuestionsContainer.innerHTML = questionsHTML;
            this.handleStep('#step-4[data-question-collection="unDiagnosed"]');
            this.handleStep('#step-5[data-question-collection="unDiagnosed"]');
        },
        getAnswer(e) {
            let isCommonQuestion = this.currentQuestion < 4;
            let dataOptionTypeElement, dataOptionType, question, category, subOptionQuestion, subOptionQuestion2, currentOptions = [], currentSubOptions = [], currentSubOptions2 = [];
            let currentQuestionIndex = this.currentQuestion - 1;
            let answerDL = {event: 'wob_question_answer', questionNumber: this.currentQuestion, answerValue: []};
            if(isCommonQuestion) {
                dataOptionTypeElement = document.querySelector(`#common-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                question = this.commonQuestions[this.currentQuestion-1].question;
                category = this.commonQuestions[this.currentQuestion-1].category;
            }
            else {
                if(this.isDiagnosedOrNot) {
                    dataOptionTypeElement = document.querySelector(`#diagnosed-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                    question = this.diagnosedQuestions[this.currentQuestion-4].question;
                    category = this.diagnosedQuestions[this.currentQuestion-4].category;
                    subOptionQuestion = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory;
                    subOptionQuestion2 = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory2;
                }
                else {
                    dataOptionTypeElement = document.querySelector(`#unDiagnosed-questions .question-answer#${this.currentStep}-questionContainer [data-options-type]`);
                    question = this.unDiagnosedQuestions[this.currentQuestion-4].question;
                    category = this.unDiagnosedQuestions[this.currentQuestion-4].category;
                    subOptionQuestion = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory;
                    subOptionQuestion2 = this.diagnosedQuestions[this.currentQuestion-4].subMultipleOptionsCategory2;
                }
            }
            // currentOptions.splice(0, currentOptions.length);

            let optionObj = {};
            dataOptionType = dataOptionTypeElement.getAttribute('data-options-type');
            dataOptionTypeElement.querySelectorAll('input[type="checkbox"]:not([data-suboption])').forEach(input => {
                if (input.checked == true) {
                    optionObj = {
                        title: `${input.value}`,
                        selected: true,
                    }
                    answerDL.answerValue.push(input.value);
                    currentOptions.push(optionObj)
                }
                else {
                    optionObj = {
                        title: `${input.value}`,
                        selected: false,
                    }
                    currentOptions.push(optionObj);
                }
            });
            this.answers[currentQuestionIndex].options = currentOptions;

            dataOptionTypeElement.querySelectorAll('input[type="checkbox"][data-suboption]').forEach(input => {
                let subOptionType = input.dataset.suboption;
                if(subOptionType == 1) {
                    if (input.checked == true) {
                        optionObj = {
                            title: `${input.value}`,
                            selected: true,
                        }
                        answerDL.answerValue.push(input.value);
                        currentSubOptions.push(optionObj)
                    }
                    else {
                        optionObj = {
                            title: `${input.value}`,
                            selected: false,
                        }
                        currentSubOptions.push(optionObj);
                    }
                }
                else {
                    if (input.checked == true) {
                        optionObj = {
                            title: `${input.value}`,
                            selected: true,
                        }
                        answerDL.answerValue.push(input.value);
                        currentSubOptions2.push(optionObj)
                    }
                    else {
                        optionObj = {
                            title: `${input.value}`,
                            selected: false,
                        }
                        currentSubOptions2.push(optionObj);
                    }
                }
            });
            this.answers[currentQuestionIndex].subOptions = currentSubOptions;
            this.answers[currentQuestionIndex].subOptions2 = currentSubOptions2;
            this.answers[currentQuestionIndex].subQuestion = subOptionQuestion;
            this.answers[currentQuestionIndex].subQuestion2 = subOptionQuestion2;

            if (dataOptionType == 'indicatorOptions') {
                this.answers[currentQuestionIndex].vas_score = dataOptionTypeElement.querySelector('input[type="range"]').value;
                answerDL.answerScrollValue = this.answers[currentQuestionIndex].vas_score;
            }
            
            this.answers[currentQuestionIndex].question = question;
            this.answers[currentQuestionIndex].category = category;
            // console.log("this.answers", this.answers);

            let qacBtn = e.target.closest('.right-navigation-button-container').getAttribute('id');

            if(this.currentQuestion > 0 && document.querySelector('.soft-disabled') == null && qacBtn != 'qac-start-quiz') {
                window.dataLayer.push(answerDL);
            }
        },
        createSummaryHTMLSteps() {
            //getting result title
            if(this.isDiagnosedOrNot == true) {
                // console.log("Inside diagnosed section of result title");
                let isConfidentManager = false;
                this.answers[8].options.forEach(option=>{
                    if(option.title == getTranslationUtility.getTranslation('Yes') && option.selected == true) {
                        isConfidentManager = true;
                        this.resultTitle = 'The Confident Manager';
                    }
                });
                console.log("isConfidentManager", isConfidentManager)
                if(!isConfidentManager) {
                    this.answers[1].options.forEach(option=>{
                        if((option.title == getTranslationUtility.getTranslation('Understand allergy treatments') && option.selected == true) || 
                        (option.title == getTranslationUtility.getTranslation('Prepare for a doctor’s appointment') && option.selected == true) || 
                        (option.title == getTranslationUtility.getTranslation('Make allergy management easier') && option.selected == true)) {
                            console.log("The Proactive Navigator")
                            this.resultTitle = 'The Proactive Navigator';
                        }
                        else if((option.title == getTranslationUtility.getTranslation('Find out more about allergies in general') && option.selected == true) || 
                        (option.title == getTranslationUtility.getTranslation('Something else') && option.selected == true)) {
                            console.log("The Curious Investigator")
                            this.resultTitle = 'The Curious Investigator';
                        }
                        else if (option.title == getTranslationUtility.getTranslation('Determine if I might have an allergy') && option.selected == true) {
                            console.log("The Juggler")
                            this.resultTitle = 'The Juggler';
                        }
                    });
                }

                this.answers[3].options.forEach(option => {
                    if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {
                        localStorage.setItem('pageviewMite', 'true');
                    }
                    if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {
                        localStorage.setItem('pageviewVenom', 'true');
                    }
                });
                this.answers[3].subOptions.forEach(subOption =>{
                     if (subOption.title == getTranslationUtility.getTranslation('Tree') && subOption.selected == true) {
                        localStorage.setItem('pageviewTree', 'true');
                    }
                    if (subOption.title == getTranslationUtility.getTranslation('Grass') && subOption.selected == true) {
                        localStorage.setItem('pageviewGrass', 'true');
                    }
                    if (subOption.title == getTranslationUtility.getTranslation('Weed') && subOption.selected == true) {
                        localStorage.setItem('pageviewWeed', 'true');
                    }
                });
            }
            else {
                console.log("Inside undiagnosed section of result title");
                this.answers[1].options.forEach(option=>{
                    if((option.title == getTranslationUtility.getTranslation('Understand allergy treatments') && option.selected == true) || 
                    (option.title == getTranslationUtility.getTranslation('Prepare for a doctor’s appointment') && option.selected == true) || 
                    (option.title == getTranslationUtility.getTranslation('Make allergy management easier') && option.selected == true)) {
                        this.resultTitle = 'The Proactive Navigator';
                    }
                    else if((option.title == getTranslationUtility.getTranslation('Find out more about allergies in general') && option.selected == true) || 
                    (option.title == getTranslationUtility.getTranslation('Something else') && option.selected == true)) {
                        this.resultTitle = 'The Curious Investigator';
                    }
                    else if (option.title == getTranslationUtility.getTranslation('Determine if I might have an allergy') && option.selected == true) {
                        this.resultTitle = 'The Juggler';
                    }
                });

                this.answers[8].options.forEach(option => {
                    if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {
                        localStorage.setItem('pageviewMite', 'true');
                    }
                    if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {
                        localStorage.setItem('pageviewVenom', 'true');
                    }
                });
                this.answers[8].subOptions.forEach(subOption =>{
                     if (subOption.title == getTranslationUtility.getTranslation('Tree') && subOption.selected == true) {
                        localStorage.setItem('pageviewTree', 'true');
                    }
                    if (subOption.title == getTranslationUtility.getTranslation('Grass') && subOption.selected == true) {
                        localStorage.setItem('pageviewGrass', 'true');
                    }
                    if (subOption.title == getTranslationUtility.getTranslation('Weed') && subOption.selected == true) {
                        localStorage.setItem('pageviewWeed', 'true');
                    }
                });
                
            }
            console.log("this.resultTitle", this.resultTitle);

            //getting number of steps
            let actionPlanSetps = {};
            if(this.isDiagnosedOrNot == true) {
                // console.log("Inside diagnosed section of number of steps");
                if(this.resultTitle == 'The Proactive Navigator') {
                    let shouldSkipD = false;
                    this.answers[1].options.forEach(option=>{
                        if (shouldSkipD) {
                            return false;
                        }
                        if(option.title == getTranslationUtility.getTranslation('Make allergy management easier') && option.selected == true) {
                            console.log("total 5 steps")//here add 5 steps html;
                            shouldSkipD = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-5');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Plan"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                                    popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                                    popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                                    popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Understand"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                                    popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                                    popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                                    popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                                    popupLinkUrl: "/pages/allergie-behandlung",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step4: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step5: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_1';
                        }
                        if(option.title == getTranslationUtility.getTranslation('Understand allergy treatments') && option.selected == true) {
                            shouldSkipD = true;
                            console.log("total 4 steps")//here add 4 steps html;
                            document.querySelector('#steps-pagination').classList.add('total-steps-4');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Understand"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Treatment options"),
                                    popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                                    popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                                    popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                                    popupLinkUrl: "/pages/allergie-behandlung",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_2';
                        }
                        if(option.title == getTranslationUtility.getTranslation('Prepare for a doctor’s appointment') && option.selected == true) {
                            shouldSkipD = true;
                            console.log("total 3 steps")//here add 3 steps html;
                            document.querySelector('#steps-pagination').classList.add('total-steps-3');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_d_3';
                        }
                    })
                }
                if(this.resultTitle == 'The Confident Manager') {
                    console.log("total 3 steps")//here add 3 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-3');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: getTranslationUtility.getTranslation("Monitor"),
                            stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                            popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: getTranslationUtility.getTranslation("Discover"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies explained simply"),
                            popupTitle: getTranslationUtility.getTranslation("Tired of itchy eyes and a runny nose?"),
                            popupText: getTranslationUtility.getTranslation("You might be having an allergic reaction. Allergies happen when your body overreacts to harmless substances like pollen or dust mites, mistaking them for threats. Want to know the top 5 allergy culprits and how to identify the symptoms?"),
                            popupLinktext: getTranslationUtility.getTranslation("Find out more"),
                            popupLinkUrl: "/pages/allergien-einfach-erklaert",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: getTranslationUtility.getTranslation("Understand"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                            popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                            popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                            popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                            popupLinkUrl: "/pages/allergie-behandlung",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'cm';
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("total 7 steps")//here add 7 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-7');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: getTranslationUtility.getTranslation("Discover"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies explained simply"),
                            popupTitle: getTranslationUtility.getTranslation("Tired of itchy eyes and a runny nose?"),
                            popupText: getTranslationUtility.getTranslation("You might be having an allergic reaction. Allergies happen when your body overreacts to harmless substances like pollen or dust mites, mistaking them for threats. Want to know the top 5 allergy culprits and how to identify the symptoms?"),
                            popupLinktext: getTranslationUtility.getTranslation("Find out more"),
                            popupLinkUrl: "/pages/allergien-einfach-erklaert",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: getTranslationUtility.getTranslation("Recognise"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies? Or a cold?"),
                            popupTitle: getTranslationUtility.getTranslation("Sniffling and snuffling? Cold or allergy?"),
                            popupText: getTranslationUtility.getTranslation("It can be confusing to know what’s causing itchy eyes, runny nose and a cough. But allergies often show different signs than a cold, such as no fever and clear, watery nasal mucus."),
                            popupLinktext: getTranslationUtility.getTranslation("See how to spot the difference between a cold and allergies"),
                            popupLinkUrl: "/pages/allergien-verstehen",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: getTranslationUtility.getTranslation("Plan"),
                            stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                            popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                            popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                            popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: getTranslationUtility.getTranslation("Understand"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                            popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                            popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                            popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                            popupLinkUrl: "/pages/allergie-behandlung",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: getTranslationUtility.getTranslation("Find"),
                            stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                            popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: true
                        },
                        step6: {
                            stepTitle: getTranslationUtility.getTranslation("Get ready"),
                            stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                            popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step7: {
                            stepTitle: getTranslationUtility.getTranslation("Monitor"),
                            stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                            popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'ci_u';
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("total 6 steps")//here add 6 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-6');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: getTranslationUtility.getTranslation("Recognise"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies? Or a cold?"),
                            popupTitle: getTranslationUtility.getTranslation("Sniffling and snuffling? Cold or allergy?"),
                            popupText: getTranslationUtility.getTranslation("It can be confusing to know what’s causing itchy eyes, runny nose and a cough. But allergies often show different signs than a cold, such as no fever and clear, watery nasal mucus."),
                            popupLinktext: getTranslationUtility.getTranslation("See how to spot the difference between a cold and allergies"),
                            popupLinkUrl: "/pages/allergien-verstehen",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: getTranslationUtility.getTranslation("Plan"),
                            stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                            popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                            popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                            popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: getTranslationUtility.getTranslation("Understand"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                            popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                            popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                            popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                            popupLinkUrl: "/pages/allergie-behandlung",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: getTranslationUtility.getTranslation("Find"),
                            stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                            popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: true
                        },
                        step5: {
                            stepTitle: getTranslationUtility.getTranslation("Get ready"),
                            stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                            popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step6: {
                            stepTitle: getTranslationUtility.getTranslation("Monitor"),
                            stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                            popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'j_u';
                }
                
            }
            else {
                console.log("Inside undiagnosed section of number of steps");
                if(this.resultTitle == 'The Proactive Navigator') {
                    let shouldSkipUd = false;
                    this.answers[1].options.forEach(option=>{
                        if(option.title == getTranslationUtility.getTranslation('Make allergy management easier') && option.selected == true) {
                            console.log("total 5 steps")//here add 5 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-5');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Plan"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                                    popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                                    popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                                    popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Understand"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                                    popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                                    popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                                    popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                                    popupLinkUrl: "/pages/allergie-behandlung",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step4: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step5: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_1';
                        }
                        else if(option.title == getTranslationUtility.getTranslation('Understand allergy treatments') && option.selected == true) {
                            console.log("total 4 steps")//here add 4 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-4');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Understand"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                                    popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                                    popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                                    popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                                    popupLinkUrl: "/pages/allergie-behandlung",
                                    fadWidgetTrigger: false
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Schedule your doctor's appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step4: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_2';
                        }
                        else if(option.title == getTranslationUtility.getTranslation('Prepare for a doctor’s appointment') && option.selected == true) {
                            console.log("total 3 steps")//here add 3 steps html;
                            shouldSkipUd = true;
                            document.querySelector('#steps-pagination').classList.add('total-steps-3');
                            actionPlanSetps = {
                                step1: {
                                    stepTitle: getTranslationUtility.getTranslation("Find"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                                    popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: true
                                },
                                step2: {
                                    stepTitle: getTranslationUtility.getTranslation("Get ready"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                                    popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                                    popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                                step3: {
                                    stepTitle: getTranslationUtility.getTranslation("Monitor"),
                                    stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                                    popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                                    popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                                    popupLinktext: "",
                                    popupLinkUrl: "",
                                    fadWidgetTrigger: false
                                },
                            }
                            this.wob_stage = 'pn_u_3';
                        }
                    })
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("total 7 steps")//here add 7 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-7');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: getTranslationUtility.getTranslation("Discover"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies explained simply"),
                            popupTitle: getTranslationUtility.getTranslation("Tired of itchy eyes and a runny nose?"),
                            popupText: getTranslationUtility.getTranslation("You might be having an allergic reaction. Allergies happen when your body overreacts to harmless substances like pollen or dust mites, mistaking them for threats. Want to know the top 5 allergy culprits and how to identify the symptoms?"),
                            popupLinktext: getTranslationUtility.getTranslation("Find out more"),
                            popupLinkUrl: "/pages/allergien-einfach-erklaert",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: getTranslationUtility.getTranslation("Recognise"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies? Or a cold?"),
                            popupTitle: getTranslationUtility.getTranslation("Sniffling and snuffling? Cold or allergy?"),
                            popupText: getTranslationUtility.getTranslation("It can be confusing to know what’s causing itchy eyes, runny nose and a cough. But allergies often show different signs than a cold, such as no fever and clear, watery nasal mucus."),
                            popupLinktext: getTranslationUtility.getTranslation("See how to spot the difference between a cold and allergies"),
                            popupLinkUrl: "/pages/allergien-verstehen",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: getTranslationUtility.getTranslation("Plan"),
                            stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                            popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                            popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                            popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: getTranslationUtility.getTranslation("Understand"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                            popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                            popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                            popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                            popupLinkUrl: "/pages/allergie-behandlung",
                            fadWidgetTrigger: false
                        },
                        step5: {
                            stepTitle: getTranslationUtility.getTranslation("Find"),
                            stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                            popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: true
                        },
                        step6: {
                            stepTitle: getTranslationUtility.getTranslation("Get ready"),
                            stepSubtitle: getTranslationUtility.getTranslation("Schedule your doctor's appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                            popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step7: {
                            stepTitle: getTranslationUtility.getTranslation("Monitor"),
                            stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                            popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'ci_u';
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("total 6 steps")//here add 6 steps html;
                    document.querySelector('#steps-pagination').classList.add('total-steps-6');
                    actionPlanSetps = {
                        step1: {
                            stepTitle: getTranslationUtility.getTranslation("Recognise"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergies? Or a cold?"),
                            popupTitle: getTranslationUtility.getTranslation("Sniffling and snuffling? Cold or allergy?"),
                            popupText: getTranslationUtility.getTranslation("It can be confusing to know what’s causing itchy eyes, runny nose and a cough. But allergies often show different signs than a cold, such as no fever and clear, watery nasal mucus."),
                            popupLinktext: getTranslationUtility.getTranslation("See how to spot the difference between a cold and allergies"),
                            popupLinkUrl: "/pages/allergien-verstehen",
                            fadWidgetTrigger: false
                        },
                        step2: {
                            stepTitle: getTranslationUtility.getTranslation("Plan"),
                            stepSubtitle: getTranslationUtility.getTranslation("Track your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Get your allergy diary"),
                            popupText: getTranslationUtility.getTranslation("Track your symptoms and gain valuable insights for you and your doctor. See how they affect your daily life and assess the effectiveness of any medication you may have taken. This information can help your doctor tailor a personalised treatment plan to help manage allergies effectively."),
                            popupLinktext: getTranslationUtility.getTranslation("Download your allergy diary now."),
                            popupLinkUrl: "https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222",
                            fadWidgetTrigger: false
                        },
                        step3: {
                            stepTitle: getTranslationUtility.getTranslation("Understand"),
                            stepSubtitle: getTranslationUtility.getTranslation("Allergy treatments"),
                            popupTitle: getTranslationUtility.getTranslation("How to treat allergies"),
                            popupText: getTranslationUtility.getTranslation("One of the best ways to manage allergies is to avoid what causes them, but that can be very difficult! The good news? There are various ways to help relieve allergy symptoms."),
                            popupLinktext: getTranslationUtility.getTranslation("Let’s take a look at allergy treatments"),
                            popupLinkUrl: "/pages/allergie-behandlung",
                            fadWidgetTrigger: false
                        },
                        step4: {
                            stepTitle: getTranslationUtility.getTranslation("Find"),
                            stepSubtitle: getTranslationUtility.getTranslation("Book a doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Find a doctor now"),
                            popupText: getTranslationUtility.getTranslation("Persistent symptoms can be frustrating. If they disrupt your daily life, it's time to see a doctor for a diagnosis and to discuss treatment options. Take a look at our easy-to-use directory to find an allergy specialist near you"),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: true
                        },
                        step5: {
                            stepTitle: getTranslationUtility.getTranslation("Get ready"),
                            stepSubtitle: getTranslationUtility.getTranslation("Prepare for your doctor’s appointment"),
                            popupTitle: getTranslationUtility.getTranslation("Maximise your appointment"),
                            popupText: getTranslationUtility.getTranslation("You may like to ") +" <a class='download-allergy-dashboard d-inline'>"+ getTranslationUtility.getTranslation("download your allergy dashboard")+ "</a>"+getTranslationUtility.getTranslation(" to discuss with your doctor. If time allows, track your symptoms with the allergy diary for 3-4 weeks before your appointment. You can continue to use the diary to see how well any treatment works."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                        step6: {
                            stepTitle: getTranslationUtility.getTranslation("Monitor"),
                            stepSubtitle: getTranslationUtility.getTranslation("Reassess your symptoms"),
                            popupTitle: getTranslationUtility.getTranslation("Are your symptoms under control?"),
                            popupText: getTranslationUtility.getTranslation("Allergies can change over time, so keep a check on how you're feeling. If you sense any changes or feel less in control of your symptoms, consider visiting your doctor to reassess your treatment. The ")+"<a href='https://cdn.shopify.com/s/files/1/0605/5156/1273/files/GC653_DE_Web_Onbording_allergie_diary_allergiecheck.pdf?v=1736487222' target='_blank' class='d-inline'>"+getTranslationUtility.getTranslation("allergy diary")+"</a>"+getTranslationUtility.getTranslation(" can help you keep track of your symptoms."),
                            popupLinktext: "",
                            popupLinkUrl: "",
                            fadWidgetTrigger: false
                        },
                    }
                    this.wob_stage = 'j_u';
                }
            }

            let StepsHTML = ``;
            if(Object.keys(actionPlanSetps).length > 0) {
                for (const [index, [key, value]] of Object.entries(Object.entries(actionPlanSetps))) {
                    console.log(index);
                    let stepNumber = parseInt(index) + 1;
                    // console.log(key);
                    // console.log(value);
                    // console.log(value.stepTitle);
                    let stepPopupContent = ``;
                    let stepPopupLink = ``;
                    if(value.popupLinkUrl != '') {
                        if((value.popupLinkUrl).indexOf('.pdf') >= 0) {
                            stepPopupLink = `<a href="${value.popupLinkUrl}" target="_blank"><u>${value.popupLinktext}</u> <i class="icon-arrow-next"></i></a>`;
                        }
                        else {
                            stepPopupLink = `<a href="${value.popupLinkUrl}" class="result-close"><u>${value.popupLinktext}</u> <i class="icon-arrow-next"></i></a>`;
                        }
                    }
                    if(!value.fadWidgetTrigger) {
                        stepPopupContent = `
                            <div class="step-text-popup-overlay"></div>
                            <div class="step-text-popup">
                                <div class="close-navigation-btn">
                                    <span class="navigation-icon icon-Component-13--1"></span>
                                </div>
                                <span class="step-title">${value.stepSubtitle}</span>
                                <h4>${value.popupTitle}</h4>
                                <p>${value.popupText}</p>
                                ${stepPopupLink}
                            </div>`;
                    }
                    else {
                        document.querySelector('.web-on-boarding .wob-result-fad-widget .fad-widget-text-content p').innerHTML = value.popupText;
                    }
                    StepsHTML += `
                    <div class="step" data-step="${key}" data-fad-widget-trigger="${value.fadWidgetTrigger}">
                        <span class="step-number">${stepNumber}</span>
                        <div class="step-text"> 
                            <span class="step-title">${value.stepTitle}</span>
                            <span class="step-subtitle">${value.stepSubtitle}</span>
                        </div>
                        ${stepPopupContent}
                    </div>
                    `;
                }
            }
            document.querySelector('#steps-pagination').innerHTML = StepsHTML;

            if (window.innerWidth <= 767) {
                if(document.querySelector('[data-fad-widget-trigger="true"]')) {
                    let fadWidgetTriggerPoint = document.querySelector('[data-fad-widget-trigger="true"]');
                    let fadWidgetTriggerPosition = fadWidgetTriggerPoint.offsetTop;
                    let fadWidgetPopupPosition = fadWidgetTriggerPosition + 50;
                    document.querySelector('.web-on-boarding .result-fad-widget-popup .wob-result-fad-widget').style.top = fadWidgetPopupPosition +'px';
                }
            }

            // steps popup
            document.querySelectorAll('#steps-pagination .step-subtitle').forEach(stepTrrigger => {
                stepTrrigger.addEventListener('click', (e) => {
                    let currentStep = e.currentTarget.closest('.step');
                    currentStep.classList.add('active');
                    if(currentStep.getAttribute('data-fad-widget-trigger') == 'true') {
                        document.querySelector('.actionplan-steps .result-fad-widget-popup').classList.add('active');
                        window.dispatchEvent(new Event('resize'));
                    }
                });
            });
            document.querySelectorAll('#steps-pagination .close-navigation-btn').forEach(stepPopupClose => {
                stepPopupClose.addEventListener('click', (e) => {
                    let currentStep = e.currentTarget.closest('.step');
                    currentStep.classList.remove('active');
                });
            });

            //to scroll to braze
            console.log("Scroll function")
            document.querySelectorAll('.download-allergy-dashboard').forEach(dashboard =>{
                console.log("Inside the element", dashboard)
                dashboard.addEventListener('click', () => {
                    console.log("Inside dashboard click event", dashboard)
                    let parentStep = dashboard.closest('.step');
                    console.log("parentStep", parentStep, document.querySelector('#wob-braze-form-main'));
                    parentStep.classList.remove('active');
                    let offsetPosition = (document.querySelector('#wob-braze-form-main').offsetTop)-60;
                    console.log("offsetPosition", offsetPosition);
                    window.scroll(0, offsetPosition);
                    // document.querySelector('#wob-braze-form-main').scrollIntoView();
                });
            });

            document.querySelectorAll('.result-close').forEach(resultClose => {
                resultClose.addEventListener('click', (e)=>{
                    let dataUrl = e.target.getAttribute('href') != null ? e.target.getAttribute('href') : e.target.parentElement.getAttribute('href') != null ? e.target.parentElement.getAttribute('href') : '/pages/allergie-aktionsplan';
                    this.closeQuizResultPopup.querySelector('.yes-btn').setAttribute("data-url", dataUrl);
                    this.closeQuizResultPopup.classList.remove('d-none');
                    
                    if(document.querySelector('.web-on-boarding .actionplan-steps .pagination .step.active')){
                        document.querySelector('.web-on-boarding .actionplan-steps .pagination .step.active').classList.remove('active');
                    }
                    if(document.querySelector('.web-on-boarding .result-fad-widget-popup.active')){
                        document.querySelector('.web-on-boarding .result-fad-widget-popup.active').classList.remove('active');
                    }
                    e.preventDefault();
                });
            });

            //getting message for result
            let selectedAllergies = 0;
            let selectedSubAllergies = 0;
            let otherAllergies = false;
            let totalSelectedAllergies = 0;
            let selectedAllergyVal = [];
            
            if(this.isDiagnosedOrNot == true) {
                // console.log("Inside diagnosed section of message");
                //calculate total selection and other selection
                this.answers[3].options.forEach(option=>{
                    if(option.selected) {
                        selectedAllergies++;
                        if(option.title == getTranslationUtility.getTranslation('Other') || option.title == getTranslationUtility.getTranslation('Other/Don’t know')) {
                            otherAllergies = true;
                        }
                        selectedAllergyVal.push(option.title);
                    }
                })
                this.answers[3].subOptions.forEach(subOption =>{
                    if(subOption.selected) {
                        selectedSubAllergies++;
                        selectedAllergyVal.push(subOption.title);
                    }
                })
                totalSelectedAllergies = selectedSubAllergies + selectedAllergies;
                // console.log("totalSelectedAllergies, otherAllergies", totalSelectedAllergies, otherAllergies);
                if(this.resultTitle == 'The Proactive Navigator') {
                    console.log("Inside Proactive Navigator");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("Dealing with allergies is challenging, but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("Dealing with ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy is challenging, but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("Dealing with multiple  allergies is challenging but discovering ways to help manage your symptoms can make a big difference. Let's explore your next steps together.");
                    }
                }
                if(this.resultTitle == 'The Confident Manager') {
                    console.log("Inside Confident Manager");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You feel in control of your allergies, which is great! We've compiled some tips and resources to help you monitor your symptoms and maintain that control.");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You feel in control of your ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy, which is great! We've compiled some tips and resources to help you monitor your symptoms and maintain that control.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You feel in control of your allergies, which is great! We've compiled some tips and resources to help you monitor your symptoms and maintain that control.");
                    }
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("Inside Juggler");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("Inside Curious Investigator");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(no)");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy. Let's work together to navigate your next steps.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(multi)");
                    }
                }
            }
            else {
                console.log("Inside undiagnosed section of message");
                this.answers[8].options.forEach(option=>{
                    if(option.selected) {
                        selectedAllergies++;
                        if(option.title == getTranslationUtility.getTranslation('Other') || option.title == getTranslationUtility.getTranslation('Other/Don’t know')) {
                            otherAllergies = true;
                        }
                        selectedAllergyVal.push(option.title);
                    }
                })
                this.answers[8].subOptions.forEach(subOption =>{
                    if(subOption.selected) {
                        selectedSubAllergies++;
                        selectedAllergyVal.push(subOption.title);
                    }
                })
                totalSelectedAllergies = selectedSubAllergies + selectedAllergies;
                // console.log("totalSelectedAllergies, otherAllergies", totalSelectedAllergies, otherAllergies);
                if(this.resultTitle == 'The Proactive Navigator') {
                    console.log("Inside Proactive Navigator");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies are causing your symptoms and want to learn how to manage them more effectively. Your action plan can guide you through your next steps.");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy is causing your symptoms and want to learn how to manage it effectively. Your action plan can guide you through your next steps.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies are causing your symptoms and want to learn how to manage them more effectively. Your action plan can guide you through your next steps.");
                    }
                }
                if(this.resultTitle == 'The Juggler') {
                    console.log("Inside Juggler");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect allergies might be causing your symptoms and would like to get some clarity. Let’s explore your concerns together and uncover some answers.");
                    }
                }
                if(this.resultTitle == 'The Curious Investigator') {
                    console.log("Inside Curious Investigator");
                    if(otherAllergies) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(no)");
                    }
                    if(totalSelectedAllergies == 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing ")+ selectedAllergyVal[0] +getTranslationUtility.getTranslation(" allergy. Let's work together to navigate your next steps.");
                    }
                    if(totalSelectedAllergies > 1 && otherAllergies == false) {
                        this.resultMessage = getTranslationUtility.getTranslation("You suspect you may be experiencing allergy symptoms. Let's work together to navigate your next steps.(multi)");
                    }
                }
            }
            // console.log("this.resultMessage", this.resultMessage);
            document.querySelector('#result-role').innerHTML = this.resultTitle;
            document.querySelector('#result-role-description').innerHTML = this.resultMessage;

            if(this.resultTitle == 'The Proactive Navigator') {
                document.querySelector('.role-logo').classList.add('proactive-navigator');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/proactive-navigator.svg?v=1732255821');
            }
            if(this.resultTitle == 'The Confident Manager') {
                document.querySelector('.role-logo').classList.add('confident-manager');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/confident-manager.svg?v=1732256312');
            }
            if(this.resultTitle == 'The Juggler') {
                document.querySelector('.role-logo').classList.add('juggler');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/juggler.svg?v=1732255819');
            }
            if(this.resultTitle == 'The Curious Investigator') {
                document.querySelector('.role-logo').classList.add('curious-investigator');
                document.querySelector('.role-logo img').setAttribute('src','https://cdn.shopify.com/s/files/1/0605/5156/1273/files/curious-investigator.svg?v=1731393221');
            }

        },
        createSummaryHTML() {
            let resultHTML;
            var dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            var todayDate = new Date().toLocaleDateString('de-DE', dateOptions);
            resultHTML = `
                <div class="block-result-header">
                    <div class="date">${todayDate}</div>
                    <h3 class="doctor-heading" data-doctor-heading>${getTranslationUtility.getTranslation('My allergy dashboard')}</h3>
                </div>
                <div class="block-result-body">
                `;
            if(this.isDiagnosedOrNot == true) {
                let diagnosisConfirmHTML = ``;
                let diagnosisConfirmOptions = ``;
                this.answers[2].options.forEach(option => {
                    diagnosisConfirmOptions = diagnosisConfirmOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                diagnosisConfirmHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation("Allergy diagnosis confirmed by a doctor")}</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${diagnosisConfirmOptions}
                            </div>
                        </div>
                    </div>
                `;

                let suspectedTriggersHTML = ``;
                let suspectedTriggersOptions = ``;
                let suspectedTriggersSubOptions = ``;
                let suspectedTriggersSubHeader = this.answers[3].subQuestion;
                this.answers[3].options.forEach(option => {
                    suspectedTriggersOptions = suspectedTriggersOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                this.answers[3].subOptions.forEach(subOption => {
                    suspectedTriggersSubOptions = suspectedTriggersSubOptions + `
                        <label class="checkbox-item ${subOption.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${subOption.title}" ${subOption.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${subOption.selected == false ? 'inactive' : ''}"></span>
                            ${subOption.title}
                        </label>`;
                });
                suspectedTriggersHTML = `
                    <div class="suspected-triggers block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation("Diagnosed allergies")}</div>
                        <div class="suspected-triggers-options block-result-options-div">
                            <div class="block-result-options">
                                <div class="block-result-suboptions">
                                    <div class="block-result-subheading">${suspectedTriggersSubHeader}:</div>                                
                                    ${suspectedTriggersSubOptions}                        
                                </div>
                                ${suspectedTriggersOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomOverviewHTML = ``;
                let indivualIndicatorContainerContent = ``;
                let options = ``;
                this.answers.forEach(answer => {
                    if (answer.category != '' && answer.category != undefined) {
                        let icon = ``;
                        if (answer.category == getTranslationUtility.getTranslation('Eyes')) {
                            icon = 'icon-DT_results_eye_icon_grey'
                        }
                        if (answer.category == getTranslationUtility.getTranslation('Nose')) {
                            icon = 'icon-DT_results_nose_icon_grey'
                        }
                        if (answer.category == getTranslationUtility.getTranslation('Tiredness')) {
                            icon = 'icon-DT_results_tiredness_icon_grey'
                        }
                        options = answer.options.length > 0 ? '' : '<div class="option-text active">'+getTranslationUtility.getTranslation('Tiredness or sleep disruptions')+'</div>';
                        answer.options.forEach(option => {
                            options = options + `
                                <div class="option-text ${option.selected == true ? 'active' : ''}">${option.title}</div>
                            `;
                        })
                        let vasClass = '';
                        if (answer.vas_score == 0) {
                            vasClass = 'zero';
                        }
                        if (answer.vas_score == 1) {
                            vasClass = 'one';
                        }
                        if (answer.vas_score < 5 && answer.vas_score > 1) {
                            vasClass = 'two';
                        }
                        if (answer.vas_score > 4) {
                            vasClass = 'three';
                        }
                        indivualIndicatorContainerContent +=
                            `
                            <div class="indivual-indicator-container text-center">
                                <div><span class="d-inline ${icon} icons"></span></div>
                                <div class="options-text-container">${options}</div>
                                <button class="indicator-button ${vasClass}">${answer.vas_score}</button>
                            </div> 
                        `;
                    }
                });
                symptomOverviewHTML = `
                    <div class="symptom-overview block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Symptom overview')}</div>                  
                        <div class="symptom-overview-options">                      
                            <div class="indicator-container">
                                <div class="d-flex flex-row flex-wrap">  
                                    ${indivualIndicatorContainerContent}
                                </div>                      
                                <div class="position-relative slider-container">
                                <input type="range" min="0" max="10" value="0" class="slider">
                                <div class="number-labels">
                                    <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                    <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                </div>
                                </div>                      
                                <div class="labels label-for-indicator">
                                    <span class="slider-not-affected indicator-text">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                    <span class="slider-very-affected indicator-text">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                </div>
                                <div class="indicator-description">
                                    ${getTranslationUtility.getTranslation('The VAS for allergic rhinitis (nose symptoms) and allergic conjunctivitis (eye symptoms) adapted from: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.')}
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                let breathingIssueHTML = ``;
                let breathingOptions = ``;
                this.answers[7].options.forEach(option => {
                    breathingOptions = breathingOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="breathing-issue" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                breathingIssueHTML = `
                    <div class="breathing-issues block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Breathing issues')}</div>                  
                        <div class="breathing-issues-options block-result-options-div">                                              
                            <div class="block-result-options">                                              
                                ${breathingOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomControlHTML = ``;
                let symptomControlOptions = ``;
                this.answers[8].options.forEach(option => {
                    symptomControlOptions = symptomControlOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom-control" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                symptomControlHTML = `
                    <div class="symptom-control block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Symptom control')}</div>
                        <div class="symptom-control-options block-result-options-div">
                        <div class="block-result-heading">${getTranslationUtility.getTranslation('IN CONTROL OF ALLERGY SYMPTOMS')}</div>
                            <div class="block-result-options">
                                ${symptomControlOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                let diagnosedAllergiesHTML = ``;
                let managingAllergiesSubOptions = ``;
                this.answers[9].subOptions.forEach(option => {
                    managingAllergiesSubOptions = managingAllergiesSubOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="diagnosed-allergies" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                let managingAllergiesSubOptions2 = ``;
                this.answers[9].subOptions2.forEach(option => {
                    managingAllergiesSubOptions2 = managingAllergiesSubOptions2 + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="diagnosed-allergies" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                diagnosedAllergiesHTML = `
                    <div class="diagnosed-allergies block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation("Allergy treatments I'm aware of")}</div>
                        <div class="diagnosed-allergies-options block-result-options-div">
                            <div class="block-result-heading">${getTranslationUtility.getTranslation("Short-term symptom relief")}</div>
                            <div class="block-result-options">
                                ${managingAllergiesSubOptions}
                            </div>
                            <div class="block-result-heading">${getTranslationUtility.getTranslation("Allergy immunotherapy")}</div>
                            <div class="block-result-options">
                                ${managingAllergiesSubOptions2}
                            </div>
                        </div>
                    </div>
                `;

                let allergiesAffectHTML = ``;
                let dailyLifeOptions = ``;
                this.answers[10].options.forEach(option => {
                    dailyLifeOptions = dailyLifeOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="allergies-affect" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                allergiesAffectHTML = `
                    <div class="allergies-affect block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation("Impacted by allergies")}</div>
                        <div class="allergies-affect-options block-result-options-div">
                            <div class="block-result-options">
                                ${dailyLifeOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                resultHTML += `
                    <div class="row diagnosed-result">
                        <div class="col-12 col-md-6 block-result-column-one">
                            ${diagnosisConfirmHTML}
                            ${suspectedTriggersHTML}
                            ${symptomOverviewHTML}
                            ${breathingIssueHTML}
                        </div>
                        <div class="col-12 col-md-6 block-result-column-two">
                            ${symptomControlHTML}
                            ${diagnosedAllergiesHTML}
                            ${allergiesAffectHTML}
                        </div>
                    </div>
                `;
            }
            else {
                let diagnosisConfirmHTML = ``;
                let diagnosisConfirmOptions = ``;
                this.answers[2].options.forEach(option => {
                    diagnosisConfirmOptions = diagnosisConfirmOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="diagnosis-confirm" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                diagnosisConfirmHTML = `
                    <div class="diagnosis-confirm block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation("Allergy diagnosis confirmed by a doctor")}</div>
                        <div class="diagnosis-confirm-options block-result-options-div">
                            <div class="block-result-options">
                                ${diagnosisConfirmOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomOverviewHTML = ``;
                let indivualIndicatorContainerContent = ``;
                let options = ``;
                this.answers.forEach(answer => {
                    if (answer.category != '' && answer.category != undefined) {
                        let icon = ``;
                        if (answer.category == getTranslationUtility.getTranslation('Eyes')) {
                            icon = 'icon-DT_results_eye_icon_grey'
                        }
                        if (answer.category == getTranslationUtility.getTranslation('Nose')) {
                            icon = 'icon-DT_results_nose_icon_grey'
                        }
                        if (answer.category == getTranslationUtility.getTranslation('Tiredness')) {
                            icon = 'icon-DT_results_tiredness_icon_grey'
                        }
                        options = answer.options.length > 0 ? '' : '<div class="option-text active">'+getTranslationUtility.getTranslation('Tiredness or sleep disruptions')+'</div>';
                        answer.options.forEach(option => {
                            options = options + `
                                <div class="option-text ${option.selected == true ? 'active' : ''}">${option.title}</div>
                            `;
                        })
                        let vasClass = '';
                        if (answer.vas_score == 0) {
                            vasClass = 'zero';
                        }
                        if (answer.vas_score == 1) {
                            vasClass = 'one';
                        }
                        if (answer.vas_score < 5 && answer.vas_score > 1) {
                            vasClass = 'two';
                        }
                        if (answer.vas_score > 4) {
                            vasClass = 'three';
                        }
                        indivualIndicatorContainerContent +=
                            `
                            <div class="indivual-indicator-container text-center">
                                <div><span class="d-inline ${icon} icons"></span></div>
                                <div class="options-text-container">${options}</div>
                                <button class="indicator-button ${vasClass}">${answer.vas_score}</button>
                            </div> 
                        `;
                    }
                });
                symptomOverviewHTML = `
                    <div class="symptom-overview block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Symptom overview')}</div>                  
                        <div class="symptom-overview-options">                      
                            <div class="indicator-container">
                                <div class="d-flex flex-row flex-wrap">  
                                    ${indivualIndicatorContainerContent}
                                </div>                      
                                <div class="position-relative slider-container">
                                <input type="range" min="0" max="10" value="0" class="slider">
                                <div class="number-labels">
                                    <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                                    <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                                </div>
                                </div>                      
                                <div class="labels label-for-indicator">
                                    <span class="slider-not-affected indicator-text">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                                    <span class="slider-very-affected indicator-text">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                                </div>
                                <div class="indicator-description">
                                    ${getTranslationUtility.getTranslation('The VAS for allergic rhinitis (nose symptoms) and allergic conjunctivitis (eye symptoms) adapted from: Bousquet J, et al. Allergic Rhinitis and its Impact on Asthma (ARIA) 2008. Allergy 2008;63 Suppl 86:8-160.')}
                                </div>
                            </div>
                        </div>
                    </div>
                `;

                let breathingIssueHTML = ``;
                let breathingOptions = ``;
                this.answers[6].options.forEach(option => {
                    breathingOptions = breathingOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                                <input type="checkbox" name="breathing-issue" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                                <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                                ${option.title}
                        </label>`;
                });
                breathingIssueHTML = `
                    <div class="breathing-issues block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Breathing issues')}</div>                  
                        <div class="breathing-issues-options block-result-options-div">                                              
                            <div class="block-result-options">                                              
                                ${breathingOptions}
                            </div>
                        </div>
                    </div>
                `;

                let symptomsSeasonHTML = ``;
                let symptomsSeasonOptions = ``;
                this.answers[7].options.forEach(option => {
                    symptomsSeasonOptions = symptomsSeasonOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="symptom-season" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                symptomsSeasonHTML = `
                    <div class="symptoms-season block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('When symptoms are worse')}</div>
                            <div class="symptoms-season-options block-result-options-div">
                            <div class="block-result-options">
                                ${symptomsSeasonOptions}
                            </div>
                        </div>
                    </div>
                `;

                let suspectedTriggersHTML = ``;
                let suspectedTriggersOptions = ``;
                let suspectedTriggersSubOptions = ``;
                let suspectedTriggersSubHeader = this.answers[3].subQuestion;
                this.answers[8].options.forEach(option => {
                    suspectedTriggersOptions = suspectedTriggersOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                this.answers[8].subOptions.forEach(subOption => {
                    suspectedTriggersSubOptions = suspectedTriggersSubOptions + `
                        <label class="checkbox-item ${subOption.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="suspected-trigger" value="${subOption.title}" ${subOption.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${subOption.selected == false ? 'inactive' : ''}"></span>
                            ${subOption.title}
                        </label>`;
                });
                suspectedTriggersHTML = `
                    <div class="suspected-triggers block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Suspected triggers')}</div>
                        <div class="suspected-triggers-options block-result-options-div">
                            <div class="block-result-options">
                                <div class="block-result-suboptions">
                                    <div class="block-result-subheading">${suspectedTriggersSubHeader}:</div>                                
                                    ${suspectedTriggersSubOptions}                        
                                </div>
                                ${suspectedTriggersOptions}
                            </div>
                        </div>
                    </div>
                `;

                let allergicConditionsHTML = ``;
                let allergicConditionsOptions = ``;
                this.answers[9].options.forEach(option => {
                    allergicConditionsOptions = allergicConditionsOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="allergic-conditions" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                allergicConditionsHTML = `
                    <div class="allergic-conditions block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('Allergic conditions in my family')}</div>
                        <div class="allergic-conditions-options block-result-options-div">
                            <div class="block-result-options">
                                ${allergicConditionsOptions}
                            </div>
                        </div>
                    </div>
                `;

                let diseaseHaveHTML = ``;
                let diseaseHaveOptions = ``;
                this.answers[10].options.forEach(option => {
                    diseaseHaveOptions = diseaseHaveOptions + `
                        <label class="checkbox-item ${option.selected == false ? 'inactive' : ''}">
                            <input type="checkbox" name="disease-have" value="${option.title}" ${option.selected == true ? 'checked' : ''} disabled>
                            <span class="checkmark ${option.selected == false ? 'inactive' : ''}"></span>
                            ${option.title}
                        </label>`;
                });
                diseaseHaveHTML = `
                    <div class="disease-have block-result-container">
                        <div class="title-container">${getTranslationUtility.getTranslation('I have or used to have')}</div>
                        <div class="disease-have-options block-result-options-div">
                            <div class="block-result-options block-result-3-options">
                            ${diseaseHaveOptions}
                            </div>
                        </div>
                    </div>
                `;
                
                resultHTML += `
                    <div class="row undiagnosed-result">
                        <div class="col-12 col-md-6 block-result-column-one">
                            ${diagnosisConfirmHTML}
                            ${symptomOverviewHTML}
                            ${breathingIssueHTML}
                        </div>
                        <div class="col-12 col-md-6 block-result-column-two">
                            ${symptomsSeasonHTML}
                            ${suspectedTriggersHTML}
                            ${allergicConditionsHTML}
                            ${diseaseHaveHTML}
                        </div>
                    </div>
                `;
            }
            resultHTML += `
                <div class="row">
                    <div class="result-button-container">
                        <button class="d-flex mx-auto">
                            <span class="buttonText save-result">${getTranslationUtility.getTranslation('Save Result')}</span>
                            <span class="icon-Group-7501-1 buttonIcon"></span>
                        </button>
                    </div>
                </div>
            </div>`;
            document.querySelector('#blockResult').innerHTML = resultHTML;

            document.querySelector('.block-result .result-button-container button').addEventListener('click', ()=>{
                document.querySelector('.braze-form-popup.quiz-popup-overlay').classList.remove('d-none');

                window.dataLayer.push({
                    'event': 'wob_report_download'
                });
            });
        },
        async sendAnswer(bodyData) {
            try {
                const response = await fetch(`https://alk-app.klarify.me/api/web-onboarding`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${window.alkAppToken}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(bodyData)
                });
                const res = await response.json();
               // console.log("================", res)
                if(response.status == 200) {
                    let pdfLink = res.link;
                    let externalId = (window.Utility?.getCookie?.('WOBID_Cookie')) || localStorage.getItem('WOBID_Cookie');;
                    let externalEmail = (window.Utility?.getCookie?.('WOB_email')) || localStorage.getItem('WOB_email');

                    const CurrDate = new Date();
                    const polandTime = new Date(
                        CurrDate.toLocaleString("en-US", { timeZone: "Europe/Warsaw" })
                    );
                    const pad = (n) => n.toString().padStart(2, '0');
                    const year = polandTime.getFullYear();
                    const month = pad(polandTime.getMonth() + 1);
                    const day = pad(polandTime.getDate());
                    const hours = pad(polandTime.getHours());
                    const minutes = pad(polandTime.getMinutes());
                    const seconds = pad(polandTime.getSeconds());

                    // Get Poland's UTC offset in minutes
                    const offsetMinutes = -polandTime.getTimezoneOffset();
                    const offsetSign = offsetMinutes >= 0 ? "+" : "-";
                    const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
                    const offsetMins = pad(Math.abs(offsetMinutes) % 60);

                    // Format full date string
                    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`;


                    let callEvents = [
                        {
                            "external_id": externalId,
                            "email": externalEmail,
                            "time": formattedDate,
                            "name": "wob_report_result_email"
                        }
                    ];
                    
                    let bodyDataMap = {
                        "external_id": externalId,
                        "url": pdfLink,
                        "newsletter_signup": this.newsletterSignupVal,
                        "wob_stage": this.wob_stage,
                        "events": callEvents,
                    };
                    this.sendPDFtoBraze(bodyDataMap);      
                }
            } catch (e) {
                console.error('API call failed', e);
            }
        },
        async sendPDFtoBraze(bodyDataMap) {
            // console.log("Inside the densPdf to braze function", bodyDataMap);
            try {
                response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${window.datahubAPIKey}`,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(bodyDataMap)
                    })
                    if(response.status === 200){
                        await response.json();
                    }
            } catch (e) {
                console.error('API call failed', e);
            }
        },   
    };
    window.webOnBoarding.init();
}